
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4hoOb", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eSUdr = parcelRequire("eSUdr");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $1s5hv = parcelRequire("1s5hv");


var $inPa6 = parcelRequire("inPa6");


var $10CSJ = parcelRequire("10CSJ");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $e4o8D = parcelRequire("e4o8D");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2vVvv = parcelRequire("2vVvv");


var $iP9x4 = parcelRequire("iP9x4");


var $4IoVL = parcelRequire("4IoVL");


var $gXrHX = parcelRequire("gXrHX");


var $7aRa9 = parcelRequire("7aRa9");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $7PLO8 = parcelRequire("7PLO8");


var $3jwuS = parcelRequire("3jwuS");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5kqgA = parcelRequire("5kqgA");


var $dA1Sn = parcelRequire("dA1Sn");


var $3WPGR = parcelRequire("3WPGR");


var $bKd7w = parcelRequire("bKd7w");


var $75Ax4 = parcelRequire("75Ax4");




const $6b87c6340da04bd8$export$34c97a669cfd186c = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`mutation UpdateCoverPictureIdMutation($contentId:String!$propertyKey:String!$propertyValue:String$versionNumber:String$isDelete:Boolean)@experimental{experimentalUpdateContentProperty(contentId:$contentId propertyKey:$propertyKey propertyValue:$propertyValue versionNumber:$versionNumber isDelete:$isDelete){success id key value}}`;



var $gr7Mm = parcelRequire("gr7Mm");
















var $btHGY = parcelRequire("btHGY");





var $4hoOb = parcelRequire("4hoOb");

const $6daaa50e0e3ea99a$var$LoadingDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        const t5 = `-${__cmplp.dynamicCoverImageHeight}px`;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $7sObp.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== __cmpls || $[8] !== t4 || $[9] !== t6) {
            t7 = {
                ...__cmpls,
                "--_1isxe5u": t4,
                "--_1tm8jw8": t6
            };
            $[7] = __cmpls;
            $[8] = t4;
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t7,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q7ysee _2rkon7od _kqswh2mm _4t3i1osq _1tke1v90 _otyr4szn",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1isxe5u": (0, $7sObp.default)(`${__cmplp.dynamicCoverImageHeight}px`),
            "--_1tm8jw8": (0, $7sObp.default)(`-${__cmplp.dynamicCoverImageHeight}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7ysee _2rkon7od _kqswh2mm _4t3i1osq _1tke1v90 _otyr4szn",
            __cmplp.className
        ])
    });
});
const $6daaa50e0e3ea99a$export$22e679d20747684f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { coverPicture: coverPicture, dynamicCoverImageHeight: dynamicCoverImageHeight, showErrorFlag: showErrorFlag, mediaConfig: mediaConfig, ssrConfig: ssrConfig, contentId: contentId, hasSSRConfigInSSRModeOrHydration: hasSSRConfigInSSRModeOrHydration, isFixedWidthImageOption: isFixedWidthImageOption, isAIGenerated: isAIGenerated } = t0;
    let t1;
    if ($[0] !== hasSSRConfigInSSRModeOrHydration || $[1] !== mediaConfig || $[2] !== ssrConfig) {
        t1 = hasSSRConfigInSSRModeOrHydration ? ssrConfig && ssrConfig.config : mediaConfig && {
            authProvider: mediaConfig.authProvider
        };
        $[0] = hasSSRConfigInSSRModeOrHydration;
        $[1] = mediaConfig;
        $[2] = ssrConfig;
        $[3] = t1;
    } else t1 = $[3];
    const mediaClientConfig = t1;
    if (mediaClientConfig) {
        const t2 = String(coverPicture.current.draft?.value.id);
        const t3 = hasSSRConfigInSSRModeOrHydration ? `contentId-${contentId}` : mediaConfig?.collection;
        let t4;
        if ($[4] !== t2 || $[5] !== t3) {
            t4 = {
                mediaItemType: "file",
                id: t2,
                collectionName: t3
            };
            $[4] = t2;
            $[5] = t3;
            $[6] = t4;
        } else t4 = $[6];
        const t5 = String(coverPicture.current.draft?.value.id);
        let t6;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                allowAnimated: true,
                mode: "full-fit",
                upscale: false
            };
            $[7] = t6;
        } else t6 = $[7];
        const t7 = hasSSRConfigInSSRModeOrHydration ? ssrConfig?.mode : undefined;
        let t8;
        if ($[8] !== coverPicture.current.draft?.value || $[9] !== dynamicCoverImageHeight || $[10] !== isAIGenerated || $[11] !== isFixedWidthImageOption || $[12] !== showErrorFlag) {
            t8 = (t9)=>{
                const { data: data, loading: loading, error: error } = t9;
                if (loading) {
                    if (isAIGenerated && (0, $6mKj3.isExperimentEnabled)("confluence_aifc_header_image_generation_experiment")) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6daaa50e0e3ea99a$var$LoadingDiv, {
                        "data-testid": "cover-pic-loading",
                        dynamicCoverImageHeight: dynamicCoverImageHeight
                    });
                }
                if (!data) return null;
                if (error) showErrorFlag();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4hoOb.ImageWrapper), {
                    "data-testid": "actual-cover-picture",
                    id: "actual-cover-picture",
                    alt: "",
                    src: data.src,
                    coverPicturePosition: coverPicture.current.draft?.value.position,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    className: "cover-picture-wrapper-dangerously-set-inner-html"
                });
            };
            $[8] = coverPicture.current.draft?.value;
            $[9] = dynamicCoverImageHeight;
            $[10] = isAIGenerated;
            $[11] = isFixedWidthImageOption;
            $[12] = showErrorFlag;
            $[13] = t8;
        } else t8 = $[13];
        let t9;
        if ($[14] !== mediaClientConfig || $[15] !== t4 || $[16] !== t5 || $[17] !== t7 || $[18] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $btHGY.MediaImageWithErrorBoundary), {
                identifier: t4,
                mediaClientConfig: mediaClientConfig,
                key: t5,
                apiConfig: t6,
                ssr: t7
            }, t8);
            $[14] = mediaClientConfig;
            $[15] = t4;
            $[16] = t5;
            $[17] = t7;
            $[18] = t8;
            $[19] = t9;
        } else t9 = $[19];
        return t9;
    }
} : ({ coverPicture: coverPicture, dynamicCoverImageHeight: dynamicCoverImageHeight, showErrorFlag: showErrorFlag, mediaConfig: mediaConfig, ssrConfig: ssrConfig, contentId: contentId, hasSSRConfigInSSRModeOrHydration: hasSSRConfigInSSRModeOrHydration, isFixedWidthImageOption: isFixedWidthImageOption, isAIGenerated: isAIGenerated })=>{
    const mediaClientConfig = hasSSRConfigInSSRModeOrHydration ? ssrConfig && ssrConfig.config : mediaConfig && {
        authProvider: mediaConfig.authProvider
    };
    if (mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $btHGY.MediaImageWithErrorBoundary), {
        identifier: {
            mediaItemType: 'file',
            id: String(coverPicture.current.draft?.value.id),
            collectionName: hasSSRConfigInSSRModeOrHydration ? `contentId-${contentId}` : mediaConfig?.collection
        },
        mediaClientConfig: mediaClientConfig,
        key: String(coverPicture.current.draft?.value.id),
        apiConfig: {
            allowAnimated: true,
            mode: 'full-fit',
            upscale: false
        },
        ssr: hasSSRConfigInSSRModeOrHydration ? ssrConfig?.mode : undefined
    }, ({ data: data, loading: loading, error: error })=>{
        if (loading) {
            // TODO: Leverage coverPictureState instead to determine if the image was AI generated
            // https://hello.jira.atlassian.cloud/browse/CCI-12712
            if (isAIGenerated && (0, $6mKj3.isExperimentEnabled)('confluence_aifc_header_image_generation_experiment')) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6daaa50e0e3ea99a$var$LoadingDiv, {
                "data-testid": "cover-pic-loading",
                dynamicCoverImageHeight: dynamicCoverImageHeight
            });
        }
        if (!data) return null;
        if (error) showErrorFlag();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4hoOb.ImageWrapper), {
            "data-testid": "actual-cover-picture",
            id: "actual-cover-picture" // need this empty alt tag for decorative images
            ,
            alt: "",
            src: data.src,
            coverPicturePosition: coverPicture.current.draft?.value.position,
            isFixedWidthImageOption: isFixedWidthImageOption,
            className: "cover-picture-wrapper-dangerously-set-inner-html"
        });
    });
};

















var $9hlns = parcelRequire("9hlns");

















var $2Maq7 = parcelRequire("2Maq7");













var $gtD4K = parcelRequire("gtD4K");


var $eEA8O = parcelRequire("eEA8O");


var $fZtQj = parcelRequire("fZtQj");


var $lGgRw = parcelRequire("lGgRw");






















var $gKvd9 = parcelRequire("gKvd9");


var $1kVeP = parcelRequire("1kVeP");


var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $hY5v2 = parcelRequire("hY5v2");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");










var $1qfLF = parcelRequire("1qfLF");


var $c6GJD = parcelRequire("c6GJD");


var $fzqvY = parcelRequire("fzqvY");

var $fb3kw = parcelRequire("fb3kw");


var $euUgw = parcelRequire("euUgw");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $2gD2K = parcelRequire("2gD2K");


var $9EtP6 = parcelRequire("9EtP6");


var $fYQcF = parcelRequire("fYQcF");

/* GradientRovoIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $826c107ecf54d2fa$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $826c107ecf54d2fa$var$svgStyles = null;
const $826c107ecf54d2fa$var$GradientRovoIcon = ({ size: size = 'medium', label: label })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        viewBox: "0 0 24 24",
        "aria-label": label,
        role: "img",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $826c107ecf54d2fa$var$sizeStyles[size]
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.7812 0.703646C11.5354 0.268228 12.4646 0.268228 13.2187 0.703646L21.1735 5.29635C21.9277 5.73177 22.3923 6.53646 22.3923 7.40729V16.5927C22.3923 17.4635 21.9277 18.2682 21.1735 18.7036L13.2187 23.2964C12.4646 23.7318 11.5354 23.7318 10.7812 23.2964L2.82642 18.7036C2.07225 18.2682 1.60767 17.4635 1.60767 16.5927V7.40729C1.60767 6.53646 2.07225 5.73177 2.82642 5.29635L10.7812 0.703646Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask0_65_236",
                maskUnits: "userSpaceOnUse",
                x: "1",
                y: "0",
                width: "22",
                height: "24",
                "mask-type": "alpha",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M10.7815 0.703646C11.5356 0.268228 12.4648 0.268228 13.219 0.703646L21.1738 5.29635C21.9279 5.73177 22.3925 6.53646 22.3925 7.40729V16.5927C22.3925 17.4635 21.9279 18.2682 21.1738 18.7036L13.219 23.2964C12.4648 23.7318 11.5356 23.7318 10.7815 23.2964L2.82666 18.7036C2.0725 18.2682 1.60791 17.4635 1.60791 16.5927V7.40729C1.60791 6.53646 2.0725 5.73177 2.82666 5.29635L10.7815 0.703646Z"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                mask: "url(#mask0_65_236)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M-22.5135 24.6991H8.60185L5.88935 -2.41176L-22.5135 -28.4972V24.6991Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M2.42558 35.5899C3.86103 32.8143 5.95704 30.6386 8.71725 29.1572C11.4775 27.6758 14.6828 27.0412 17.928 27.4185L0.469634 -5.11025C-2.42537 -4.58098 -5.2402 -3.60438 -7.9493 -2.15039C-10.6584 -0.696407 -12.9879 1.04419 -15.0109 3.09312L2.43287 35.5947L2.42558 35.5899Z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12.4885 15.9074C7.6716 17.9211 3.99287 21.2471 3.84304 25.8504C3.84304 25.8504 3.84561 25.8739 3.84317 25.8855C3.83332 26.2275 3.83962 26.5734 3.87076 26.9264C3.87202 26.9294 3.87327 26.9324 3.87452 26.9354C3.90382 27.2927 3.95486 27.6586 4.02641 28.0299C4.04474 28.1173 4.07178 28.2081 4.09011 28.2955C4.15579 28.5918 4.22146 28.8882 4.31634 29.1935C4.442 29.5986 4.58816 30.0091 4.76352 30.4286C5.08794 31.2046 5.46851 31.8973 5.87919 32.5141C6.42593 33.3345 7.02552 34.0201 7.62279 34.587C7.77289 34.7284 7.92047 34.8638 8.07175 34.9907C8.7748 35.4711 9.80174 36.1084 11.5225 36.9166C12.6464 37.4464 14.0741 38.0498 15.9023 38.7322C17.3643 36.4843 20.0395 34.7358 22.5433 32.7775C24.5199 31.2296 26.3844 29.5526 27.4471 27.3941C28.4218 25.4168 28.4471 22.9528 27.3786 20.397C24.7043 14.0001 18.7848 13.2716 12.4934 15.9018L12.4885 15.9074Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                        id: "mask1_65_236",
                        maskUnits: "userSpaceOnUse",
                        x: "-16",
                        y: "-6",
                        width: "34",
                        height: "42",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M2.42503 35.5899C3.86048 32.8143 5.95649 30.6386 8.7167 29.1572C11.4769 27.6758 14.6822 27.0412 17.9274 27.4185L0.469085 -5.11025C-2.42592 -4.58098 -5.24075 -3.60438 -7.94985 -2.15039C-10.6589 -0.696407 -12.9885 1.04419 -15.0115 3.09312L2.43232 35.5947L2.42503 35.5899Z",
                            fill: "#BF63F3"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        mask: "url(#mask1_65_236)",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M12.488 15.9073C7.67118 17.921 3.99245 21.247 3.84261 25.8503C3.84261 25.8503 3.84518 25.8739 3.84275 25.8854C3.83289 26.2275 3.83919 26.5733 3.87034 26.9264C3.87159 26.9294 3.87284 26.9323 3.87409 26.9353C3.90339 27.2927 3.95444 27.6585 4.02598 28.0299C4.04432 28.1173 4.07135 28.208 4.08969 28.2954C4.15536 28.5918 4.22104 28.8882 4.31591 29.1934C4.44158 29.5985 4.58773 30.0091 4.7631 30.4285C5.08752 31.2046 5.46808 31.8973 5.87877 32.514C6.42551 33.3344 7.0251 34.02 7.62237 34.587C7.77246 34.7284 7.92004 34.8638 8.07132 34.9906C8.77437 35.4711 9.80131 36.1083 11.522 36.9166C12.646 37.4463 14.0737 38.0498 15.9019 38.7322C17.3639 36.4842 20.0391 34.7358 22.5429 32.7774C24.5195 31.2295 26.3839 29.5525 27.4467 27.394C28.4214 25.4167 28.4466 22.9528 27.3782 20.397C24.7039 14 18.7843 13.2716 12.493 15.9017L12.488 15.9073Z",
                            fill: "#AE2A19"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M23.208 -15.2226L-5.4511 -10.0558C-5.4511 -10.0558 -2.50006 3.04461 -8.90569 14.9706C-8.02861 15.0379 -7.1413 15.0785 -6.2441 15.0659C10.2558 14.8334 23.4404 1.27201 23.2079 -15.2279L23.208 -15.2226Z",
                        fill: "#82B536"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                        id: "mask2_65_236",
                        maskUnits: "userSpaceOnUse",
                        x: "-16",
                        y: "-6",
                        width: "34",
                        height: "42",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M2.42503 35.5899C3.86048 32.8143 5.95649 30.6386 8.7167 29.1572C11.4769 27.6758 14.6822 27.0412 17.9274 27.4185L0.469085 -5.11025C-2.42592 -4.58098 -5.24075 -3.60438 -7.94985 -2.15039C-10.6589 -0.696407 -12.9885 1.04419 -15.0115 3.09312L2.43232 35.5947L2.42503 35.5899Z",
                            fill: "#BF63F3"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        mask: "url(#mask2_65_236)",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M23.2076 -15.2226L-5.45147 -10.0558C-5.45147 -10.0558 -2.50043 3.04461 -8.90606 14.9706C-8.02898 15.0379 -7.14166 15.0785 -6.24447 15.0659C10.2554 14.8334 23.44 1.27201 23.2076 -15.2279L23.2076 -15.2226Z",
                            fill: "#164B35"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.2922 5.78246C11.7411 5.53468 12.289 5.53923 12.7342 5.79611L17.066 8.29705C17.5194 8.5586 17.8 9.04386 17.8 9.56661V14.5686C17.8 15.0934 17.5211 15.5765 17.0664 15.8379L13.8102 17.7179C13.8173 17.6979 13.8241 17.6777 13.8306 17.6574C13.891 17.47 13.923 17.272 13.923 17.0695L13.923 12.0676C13.923 11.3804 13.5575 10.7468 12.9614 10.404L10.5341 9.00319V7.06564C10.5341 6.91296 10.5577 6.76382 10.6024 6.62264C10.7122 6.28094 10.9457 5.98513 11.2652 5.80047L11.2662 5.79992C11.2754 5.79463 11.2841 5.78876 11.2922 5.78246Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.1899 6.42211L6.93363 8.30209C6.47892 8.5635 6.20001 9.04661 6.20001 9.57144L6.20001 14.5734C6.20001 15.0961 6.48057 15.5814 6.93393 15.8429L11.2658 18.3439C11.711 18.6007 12.2589 18.6053 12.7078 18.3575C12.716 18.3512 12.7246 18.3454 12.7338 18.3401C13.0536 18.1556 13.2875 17.8597 13.3975 17.5178C13.4423 17.3765 13.4659 17.2272 13.4659 17.0744V15.1368L11.0388 13.7361C10.4427 13.3933 10.077 12.7595 10.077 12.0724V7.07046C10.077 6.86833 10.1089 6.67056 10.1692 6.48338C10.1758 6.46283 10.1826 6.4424 10.1899 6.42211Z",
                fill: "white"
            })
        ]
    });
};
var $826c107ecf54d2fa$export$2e2bcd8739ae039 = $826c107ecf54d2fa$var$GradientRovoIcon;


const $7498a8c5d7a74725$export$12cc65019788286c = {
    photorealistic: 'photorealistic',
    abstract: 'abstract',
    watercolors: 'watercolors',
    graphic_design: 'graphic_design',
    landscape: 'landscape'
};


const $6b4df58911fcb5f7$var$i18n = (0, $cgtv4.defineMessages)({
    getCreativeLabel: {
        id: "ai-image-generation.rovo-header-image-generator.get-creative-label",
        defaultMessage: "Get creative with Rovo"
    },
    getCreativePlaceholder: {
        id: "ai-image-generation.rovo-header-image-generator.get-creative-placeholder",
        defaultMessage: "Describe an image to create"
    },
    rovoIconAlt: {
        id: "ai-image-generation.rovo-header-image-generator.rovo-icon-alt",
        defaultMessage: "Rovo icon"
    },
    submitButtonLabel: {
        id: "ai-image-generation.rovo-header-image-generator.submit-button-label",
        defaultMessage: "Generate AI header image"
    },
    pickStyleLabel: {
        id: "ai-image-generation.rovo-header-image-generator.pick-style-label",
        defaultMessage: "Pick a style"
    },
    stylePhotorealistic: {
        id: "ai-image-generation.rovo-header-image-generator.style-photorealistic",
        defaultMessage: "Photorealistic"
    },
    styleAbstract: {
        id: "ai-image-generation.rovo-header-image-generator.style-abstract",
        defaultMessage: "Abstract"
    },
    styleWatercolors: {
        id: "ai-image-generation.rovo-header-image-generator.style-watercolors",
        defaultMessage: "Watercolors"
    },
    styleGraphicDesign: {
        id: "ai-image-generation.rovo-header-image-generator.style-graphic-design",
        defaultMessage: "Graphic Design"
    },
    styleLandscape: {
        id: "ai-image-generation.rovo-header-image-generator.style-landscape",
        defaultMessage: "Landscape"
    }
});
const $6b4df58911fcb5f7$var$styles = {
    divider: "_1mou12x7 _1bsb1osq _4t3it94y _bfhk7qp0",
    rovoIcon: "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o",
    imagePromptContainer: "_2rko1mok _1dqonqa1 _1h6d1l7x _189ee4h9 _18zrutpp _1bsb1osq _1e0c1txw _4cvr1h6o _1wpz1fhb _1bah1h6o _bfhkvuon _85i5u2gc _1pfhutpp",
    stack: "_1bsb1osq _2lx21bp4"
};
const $6b4df58911fcb5f7$export$ea36b789677ce46b = ({ generateAIHeaderImage: generateAIHeaderImage, deletePreviousHeaderImage: deletePreviousHeaderImage })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedTheme, setSelectedTheme] = (0, $42omo.useState)(null);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError } = (0, $fYQcF.useAIEventsInstrumentation)({
        product: 'confluence',
        subproduct: 'confluence',
        aiFeatureName: 'aiHeaderImageGeneration',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        source: 'rovoHeaderImageGenerator'
    });
    const themeOptions = [
        {
            label: formatMessage($6b4df58911fcb5f7$var$i18n.stylePhotorealistic),
            value: (0, $7498a8c5d7a74725$export$12cc65019788286c).photorealistic
        },
        {
            label: formatMessage($6b4df58911fcb5f7$var$i18n.styleAbstract),
            value: (0, $7498a8c5d7a74725$export$12cc65019788286c).abstract
        },
        {
            label: formatMessage($6b4df58911fcb5f7$var$i18n.styleWatercolors),
            value: (0, $7498a8c5d7a74725$export$12cc65019788286c).watercolors
        },
        {
            label: formatMessage($6b4df58911fcb5f7$var$i18n.styleGraphicDesign),
            value: (0, $7498a8c5d7a74725$export$12cc65019788286c).graphic_design
        },
        {
            label: formatMessage($6b4df58911fcb5f7$var$i18n.styleLandscape),
            value: (0, $7498a8c5d7a74725$export$12cc65019788286c).landscape
        }
    ]; /* IMPORTANT: The experiment `confluence_aifc_header_image_generation_experiment` must always be gated behind `aifc_create_enabled`
      on Statsig. Otherwise, this component will be shown outside of the AIFC release */ 
    const isExperimentEnabled = (0, $c6GJD.default).getExperimentValue('confluence_aifc_header_image_generation_experiment', 'isEnabled', false);
    if (!generateAIHeaderImage || !isExperimentEnabled) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $6b4df58911fcb5f7$var$styles.divider
            }),
            (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fzqvY.default), {
                onSubmit: async (data)=>{
                    const useRawPrompt = !selectedTheme?.value; // Track that user initiated AI image generation
                    trackAIInteractionInit({
                        attributes: {
                            promptLength: data.promptInput?.length || 0,
                            useRawPrompt: useRawPrompt,
                            selectedTheme: selectedTheme?.value || 'none'
                        }
                    });
                    deletePreviousHeaderImage?.();
                    try {
                        // Generate the AI header image
                        await generateAIHeaderImage({
                            adfContent: data.promptInput,
                            useRawPrompt: useRawPrompt,
                            ...selectedTheme?.value && {
                                theme: selectedTheme.value
                            }
                        }); // Track successful result view
                        trackAIResultView({
                            attributes: {
                                promptLength: data.promptInput?.length || 0,
                                useRawPrompt: useRawPrompt,
                                selectedTheme: selectedTheme?.value || 'none'
                            }
                        });
                    } catch (error) {
                        // Track error if generation fails
                        trackAIResultError({
                            aiErrorMessage: error instanceof Error ? error.message : 'Unknown error',
                            aiErrorCode: error?.code
                        });
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.075",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $6b4df58911fcb5f7$var$styles.rovoIcon,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $826c107ecf54d2fa$export$2e2bcd8739ae039), {
                                    label: formatMessage($6b4df58911fcb5f7$var$i18n.rovoIconAlt)
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("label", {
                                htmlFor: "get-creative-text-area",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "medium",
                                    id: "get-creative-label",
                                    children: formatMessage($6b4df58911fcb5f7$var$i18n.getCreativeLabel)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        space: "space.100",
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)("label", {
                                    htmlFor: "theme-picker",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "small",
                                        weight: "semibold",
                                        children: formatMessage($6b4df58911fcb5f7$var$i18n.pickStyleLabel)
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    paddingBlockStart: "space.050",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                                        inputId: "theme-picker",
                                        options: themeOptions,
                                        value: selectedTheme,
                                        onChange: (newValue)=>setSelectedTheme(newValue),
                                        placeholder: formatMessage($6b4df58911fcb5f7$var$i18n.pickStyleLabel)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $6b4df58911fcb5f7$var$styles.imagePromptContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            xcss: $6b4df58911fcb5f7$var$styles.stack,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    isRequired: true,
                                    name: "promptInput",
                                    id: "get-creative-text-area",
                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                                placeholder: formatMessage($6b4df58911fcb5f7$var$i18n.getCreativePlaceholder),
                                                appearance: "none",
                                                ...fieldProps
                                            })
                                        })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                    space: "space.075",
                                    alignInline: "end",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        appearance: "primary",
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($euUgw))),
                                        label: formatMessage($6b4df58911fcb5f7$var$i18n.submitButtonLabel),
                                        shape: "circle",
                                        type: "submit"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                onSubmit: async (data)=>{
                    const useRawPrompt = !selectedTheme?.value; // Track that user initiated AI image generation
                    trackAIInteractionInit({
                        attributes: {
                            promptLength: data.promptInput?.length || 0,
                            useRawPrompt: useRawPrompt,
                            selectedTheme: selectedTheme?.value || 'none'
                        }
                    });
                    deletePreviousHeaderImage?.();
                    try {
                        // Generate the AI header image
                        await generateAIHeaderImage({
                            adfContent: data.promptInput,
                            useRawPrompt: useRawPrompt,
                            ...selectedTheme?.value && {
                                theme: selectedTheme.value
                            }
                        }); // Track successful result view
                        trackAIResultView({
                            attributes: {
                                promptLength: data.promptInput?.length || 0,
                                useRawPrompt: useRawPrompt,
                                selectedTheme: selectedTheme?.value || 'none'
                            }
                        });
                    } catch (error) {
                        // Track error if generation fails
                        trackAIResultError({
                            aiErrorMessage: error instanceof Error ? error.message : 'Unknown error',
                            aiErrorCode: error?.code
                        });
                    }
                },
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.075",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: $6b4df58911fcb5f7$var$styles.rovoIcon,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $826c107ecf54d2fa$export$2e2bcd8739ae039), {
                                            label: formatMessage($6b4df58911fcb5f7$var$i18n.rovoIconAlt)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)("label", {
                                        htmlFor: "get-creative-text-area",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "medium",
                                            id: "get-creative-label",
                                            children: formatMessage($6b4df58911fcb5f7$var$i18n.getCreativeLabel)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                                space: "space.100",
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)("label", {
                                            htmlFor: "theme-picker",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                weight: "semibold",
                                                children: formatMessage($6b4df58911fcb5f7$var$i18n.pickStyleLabel)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            paddingBlockStart: "space.050",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                                                inputId: "theme-picker",
                                                options: themeOptions,
                                                value: selectedTheme,
                                                onChange: (newValue)=>setSelectedTheme(newValue),
                                                placeholder: formatMessage($6b4df58911fcb5f7$var$i18n.pickStyleLabel)
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $6b4df58911fcb5f7$var$styles.imagePromptContainer,
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                    xcss: $6b4df58911fcb5f7$var$styles.stack,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            isRequired: true,
                                            name: "promptInput",
                                            id: "get-creative-text-area",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                                        placeholder: formatMessage($6b4df58911fcb5f7$var$i18n.getCreativePlaceholder),
                                                        appearance: "none",
                                                        ...fieldProps
                                                    })
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                            space: "space.075",
                                            alignInline: "end",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                                appearance: "primary",
                                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($euUgw))),
                                                label: formatMessage($6b4df58911fcb5f7$var$i18n.submitButtonLabel),
                                                shape: "circle",
                                                type: "submit"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
            })
        ]
    });
};









var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");
















var $ghftu = parcelRequire("ghftu");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $dTk3A = parcelRequire("dTk3A");








var $jVylI = parcelRequire("jVylI");

const $98591a14e75c6a83$var$i18n = (0, $cgtv4.defineMessages)({
    fixedWidthSelectOption: {
        id: "content-topper.page-title.popup.fixed-width.option",
        defaultMessage: "Fixed width"
    },
    fullWidthSelectOption: {
        id: "content-topper.page-title.popup.full-width.option",
        defaultMessage: "Full width"
    }
});
const $98591a14e75c6a83$export$6164b97a36f48473 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { userOffline: userOffline, onImageWidthChange: onImageWidthChange, selectedWidth: t1, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected } = t0;
    const selectedWidth = t1 === undefined ? (0, $jVylI.COVERPICTUREWIDTH).FULL : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[0] !== createAnalyticsEvent) {
        t2 = (coverPictureWidth)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    source: "widthToggleDropdownButton",
                    actionSubject: "button",
                    actionSubjectId: `${coverPictureWidth}WidthToggleDropdownButton`
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t2;
    } else t2 = $[1];
    const createWidthToggleDropdownAnalytics = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $dTk3A.layers).dialog();
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== selectedWidth || $[4] !== userOffline) {
        t4 = (t5)=>{
            const { triggerRef: triggerRef, ...props } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...props,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "",
                    size: "small"
                }),
                ref: triggerRef,
                shouldFitContainer: true,
                style: {
                    textAlign: "left"
                },
                isDisabled: userOffline
            }, selectedWidth == (0, $jVylI.COVERPICTUREWIDTH).FULL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $98591a14e75c6a83$var$i18n.fullWidthSelectOption) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $98591a14e75c6a83$var$i18n.fixedWidthSelectOption));
        };
        $[3] = selectedWidth;
        $[4] = userOffline;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== createWidthToggleDropdownAnalytics || $[7] !== onCoverImageWidthDropdownOptionSelected || $[8] !== onImageWidthChange || $[9] !== selectedWidth) {
        t5 = ()=>{
            onImageWidthChange((0, $jVylI.COVERPICTUREWIDTH).FULL);
            createWidthToggleDropdownAnalytics((0, $jVylI.COVERPICTUREWIDTH).FULL);
            onCoverImageWidthDropdownOptionSelected?.(selectedWidth !== (0, $jVylI.COVERPICTUREWIDTH).FULL);
        };
        $[6] = createWidthToggleDropdownAnalytics;
        $[7] = onCoverImageWidthDropdownOptionSelected;
        $[8] = onImageWidthChange;
        $[9] = selectedWidth;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $98591a14e75c6a83$var$i18n.fullWidthSelectOption);
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: (0, $jVylI.COVERPICTUREWIDTH).FULL,
            onClick: t5,
            testId: "coverPictureFullWidthToggleDropdownItem"
        }, t6);
        $[12] = t5;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== createWidthToggleDropdownAnalytics || $[15] !== onCoverImageWidthDropdownOptionSelected || $[16] !== onImageWidthChange || $[17] !== selectedWidth) {
        t8 = ()=>{
            onImageWidthChange((0, $jVylI.COVERPICTUREWIDTH).FIXED);
            createWidthToggleDropdownAnalytics((0, $jVylI.COVERPICTUREWIDTH).FIXED);
            onCoverImageWidthDropdownOptionSelected?.(selectedWidth !== (0, $jVylI.COVERPICTUREWIDTH).FIXED);
        };
        $[14] = createWidthToggleDropdownAnalytics;
        $[15] = onCoverImageWidthDropdownOptionSelected;
        $[16] = onImageWidthChange;
        $[17] = selectedWidth;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $98591a14e75c6a83$var$i18n.fixedWidthSelectOption);
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: (0, $jVylI.COVERPICTUREWIDTH).FIXED,
            onClick: t8,
            testId: "coverPictureFixedWidthToggleDropdownItem"
        }, t9);
        $[20] = t8;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, t7, t10);
        $[22] = t10;
        $[23] = t7;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t11 || $[26] !== t4) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            placement: "bottom-start",
            zIndex: t3,
            shouldRenderToParent: true,
            shouldFitContainer: true,
            trigger: t4
        }, t11);
        $[25] = t11;
        $[26] = t4;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
} : ({ userOffline: userOffline, onImageWidthChange: onImageWidthChange, selectedWidth: selectedWidth = (0, $jVylI.COVERPICTUREWIDTH).FULL, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const createWidthToggleDropdownAnalytics = (0, $42omo.useCallback)((coverPictureWidth)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                source: `widthToggleDropdownButton`,
                actionSubject: 'button',
                actionSubjectId: `${coverPictureWidth}WidthToggleDropdownButton`
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        placement: "bottom-start",
        zIndex: (0, $dTk3A.layers).dialog(),
        shouldRenderToParent: true,
        shouldFitContainer: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...props,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "",
                    size: "small"
                }),
                ref: triggerRef,
                shouldFitContainer: true,
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    textAlign: 'left'
                },
                isDisabled: userOffline
            }, selectedWidth == (0, $jVylI.COVERPICTUREWIDTH).FULL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $98591a14e75c6a83$var$i18n.fullWidthSelectOption) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $98591a14e75c6a83$var$i18n.fixedWidthSelectOption))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: (0, $jVylI.COVERPICTUREWIDTH).FULL,
        onClick: ()=>{
            onImageWidthChange((0, $jVylI.COVERPICTUREWIDTH).FULL);
            createWidthToggleDropdownAnalytics((0, $jVylI.COVERPICTUREWIDTH).FULL);
            onCoverImageWidthDropdownOptionSelected?.(selectedWidth !== (0, $jVylI.COVERPICTUREWIDTH).FULL);
        },
        testId: "coverPictureFullWidthToggleDropdownItem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $98591a14e75c6a83$var$i18n.fullWidthSelectOption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: (0, $jVylI.COVERPICTUREWIDTH).FIXED,
        onClick: ()=>{
            onImageWidthChange((0, $jVylI.COVERPICTUREWIDTH).FIXED);
            createWidthToggleDropdownAnalytics((0, $jVylI.COVERPICTUREWIDTH).FIXED);
            onCoverImageWidthDropdownOptionSelected?.(selectedWidth !== (0, $jVylI.COVERPICTUREWIDTH).FIXED);
        },
        testId: "coverPictureFixedWidthToggleDropdownItem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $98591a14e75c6a83$var$i18n.fixedWidthSelectOption))));
};



var $f7B1p = parcelRequire("f7B1p");







const $d69b5edb6613d5ce$export$d3c50eeab3c808b = async (downloadLink)=>{
    return (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/unsplash/download`, {
        method: 'POST',
        body: JSON.stringify({
            downloadLink: downloadLink
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
        });
        throw error;
    });
};


const $e611c24abe969f89$var$i18n = (0, $cgtv4.defineMessages)({
    popupTitleLabel: {
        id: "content-topper.page-title.popup.label",
        defaultMessage: "Header image"
    },
    popupTitleLabelSubtext: {
        id: "content-topper.page-title.popup.label.subtext",
        defaultMessage: "We recommend images 1100px or wider."
    },
    repositionButton: {
        id: "content-topper.page-title.popup.reposition",
        defaultMessage: "Reposition"
    },
    removeHeaderButton: {
        id: "content-topper.page-title.popup.remove-image",
        defaultMessage: "Remove image"
    }
});
const $e611c24abe969f89$var$PopupWrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.200',
    width: '280px',
    userSelect: 'none'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e611c24abe969f89$var$DeleteButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1gqwidpf _q93c3f71 _1v09u2gc _p55o3f71",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1gqwidpf _q93c3f71 _1v09u2gc _p55o3f71",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e611c24abe969f89$var$PositionIconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkyh40 _2hwxidpf _otyridpf _18u0j39m _t9ec2i46",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkyh40 _2hwxidpf _otyridpf _18u0j39m _t9ec2i46",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e611c24abe969f89$var$MenuOptionsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_y3gn1e5h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});
const $e611c24abe969f89$export$5e27412e512156d4 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(43);
    const { imageSrc: imageSrc, imageAltText: imageAltText, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, coverPictureState: coverPictureState, closePopup: closePopup, setIsUploadingPicture: setIsUploadingPicture, handleUnsplashUpload: handleUnsplashUpload, onReposition: onReposition, onDelete: onDelete, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, userOffline: userOffline, contentId: contentId, isPageTitleComponent: isPageTitleComponent, onImageWidthChange: onImageWidthChange, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected, generateAIHeaderImage: generateAIHeaderImage } = t0;
    const [t1] = (0, $ep3mz.usePageState)();
    const { spaceKey: spaceKey } = t1;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t2;
    if ($[0] !== closePopup || $[1] !== coverPictureState || $[2] !== experienceTracker || $[3] !== handleUnsplashUpload || $[4] !== setIsUploadingPicture) {
        t2 = async (url, downloadLink)=>{
            experienceTracker.start({
                name: (0, $irVI7.COVER_PICTURE_UNSPLASH_UPLOAD_EXPERIENCE)
            });
            coverPictureState.setIsAIUnsplashImage(false);
            await (0, $d69b5edb6613d5ce$export$d3c50eeab3c808b)(downloadLink);
            handleUnsplashUpload(url);
            setIsUploadingPicture(true);
            coverPictureState.setIsUploadingPicture(true);
            closePopup();
        };
        $[0] = closePopup;
        $[1] = coverPictureState;
        $[2] = experienceTracker;
        $[3] = handleUnsplashUpload;
        $[4] = setIsUploadingPicture;
        $[5] = t2;
    } else t2 = $[5];
    const onUnsplashImageClick = t2;
    let t3;
    if ($[6] !== coverPictureState || $[7] !== onUnsplashImageClick) {
        t3 = async (t4)=>{
            const { fullSizeImageUrl: fullSizeImageUrl, downloadLink: downloadLink_0 } = t4;
            await onUnsplashImageClick(fullSizeImageUrl, downloadLink_0);
            coverPictureState.setIsChangingPicture(false);
        };
        $[6] = coverPictureState;
        $[7] = onUnsplashImageClick;
        $[8] = t3;
    } else t3 = $[8];
    const handleImageSelection = t3;
    const t4 = dropdownRef;
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e611c24abe969f89$var$i18n.popupTitleLabelSubtext);
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e611c24abe969f89$var$i18n.popupTitleLabel);
        $[10] = t6;
    } else t6 = $[10];
    const t7 = dropdownPopupComponentRef;
    let t8;
    if ($[11] !== contentId || $[12] !== handleImageSelection || $[13] !== imageAltText || $[14] !== imageSrc || $[15] !== initialUnsplashInfoArray || $[16] !== isPageTitleComponent || $[17] !== openMediaBrowser || $[18] !== t7 || $[19] !== userOffline) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hY5v2.UnsplashSearch), {
            selectedImageUrl: imageSrc,
            imageAltText: imageAltText,
            initialUnsplashResults: initialUnsplashInfoArray,
            idPrefix: "unsplash-popup",
            helperMessage: t5,
            handleImageSelection: handleImageSelection,
            openMediaBrowser: openMediaBrowser,
            sectionLabel: t6,
            dropdownPopupComponentRef: t7,
            isDisabled: userOffline,
            contentId: contentId,
            isPageTitleComponent: isPageTitleComponent,
            isNoImageAllowed: false,
            analyticsSource: "editorPageCoverPicture",
            analyticsActionSubject: "headerImageUpload",
            analyticsActionSubjectId: "headerImageUploadButtonClicked",
            enableBottomSpacing: false
        });
        $[11] = contentId;
        $[12] = handleImageSelection;
        $[13] = imageAltText;
        $[14] = imageSrc;
        $[15] = initialUnsplashInfoArray;
        $[16] = isPageTitleComponent;
        $[17] = openMediaBrowser;
        $[18] = t7;
        $[19] = userOffline;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== coverPictureState.state || $[22] !== onCoverImageWidthDropdownOptionSelected || $[23] !== onImageWidthChange || $[24] !== spaceKey || $[25] !== userOffline) {
        t9 = !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && typeof onImageWidthChange === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98591a14e75c6a83$export$6164b97a36f48473), {
            onImageWidthChange: onImageWidthChange,
            userOffline: userOffline,
            selectedWidth: coverPictureState.state.coverPictureWidth,
            onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected
        }) : null;
        $[21] = coverPictureState.state;
        $[22] = onCoverImageWidthDropdownOptionSelected;
        $[23] = onImageWidthChange;
        $[24] = spaceKey;
        $[25] = userOffline;
        $[26] = t9;
    } else t9 = $[26];
    let t10;
    if ($[27] !== onReposition || $[28] !== userOffline) {
        t10 = typeof onReposition === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$PositionIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kVeP))), {
                label: "",
                spacing: "none"
            })),
            testId: "reposition-image-button",
            isDisabled: userOffline,
            onClick: onReposition,
            shouldFitContainer: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$MenuOptionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e611c24abe969f89$var$i18n.repositionButton))) : null;
        $[27] = onReposition;
        $[28] = userOffline;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== generateAIHeaderImage || $[31] !== onDelete) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6b4df58911fcb5f7$export$ea36b789677ce46b), {
            generateAIHeaderImage: generateAIHeaderImage,
            deletePreviousHeaderImage: onDelete
        });
        $[30] = generateAIHeaderImage;
        $[31] = onDelete;
        $[32] = t11;
    } else t11 = $[32];
    let t12;
    if ($[33] !== onDelete || $[34] !== userOffline) {
        t12 = typeof onDelete === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$DeleteButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                label: ""
            }),
            shouldFitContainer: true,
            onClick: onDelete,
            isDisabled: userOffline,
            testId: "remove-image-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$MenuOptionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e611c24abe969f89$var$i18n.removeHeaderButton)))) : null;
        $[33] = onDelete;
        $[34] = userOffline;
        $[35] = t12;
    } else t12 = $[35];
    let t13;
    if ($[36] !== t10 || $[37] !== t11 || $[38] !== t12 || $[39] !== t4 || $[40] !== t8 || $[41] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            ref: t4,
            xcss: $e611c24abe969f89$var$PopupWrapperStyles,
            space: "space.100"
        }, t8, t9, t10, t11, t12);
        $[36] = t10;
        $[37] = t11;
        $[38] = t12;
        $[39] = t4;
        $[40] = t8;
        $[41] = t9;
        $[42] = t13;
    } else t13 = $[42];
    return t13;
} : ({ imageSrc: imageSrc, imageAltText: imageAltText, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, coverPictureState: coverPictureState, closePopup: closePopup, setIsUploadingPicture: setIsUploadingPicture, handleUnsplashUpload: handleUnsplashUpload, onReposition: onReposition, onDelete: onDelete, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, userOffline: userOffline, contentId: contentId, isPageTitleComponent: isPageTitleComponent, onImageWidthChange: onImageWidthChange, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected, generateAIHeaderImage: generateAIHeaderImage })=>{
    const [{ spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const onUnsplashImageClick = (0, $42omo.useCallback)(async (url, downloadLink)=>{
        experienceTracker.start({
            name: (0, $irVI7.COVER_PICTURE_UNSPLASH_UPLOAD_EXPERIENCE)
        });
        coverPictureState.setIsAIUnsplashImage(false);
        await (0, $d69b5edb6613d5ce$export$d3c50eeab3c808b)(downloadLink);
        handleUnsplashUpload(url);
        setIsUploadingPicture(true);
        coverPictureState.setIsUploadingPicture(true);
        closePopup();
    }, [
        experienceTracker,
        closePopup,
        coverPictureState,
        handleUnsplashUpload,
        setIsUploadingPicture
    ]);
    const handleImageSelection = (0, $42omo.useCallback)(async ({ fullSizeImageUrl: fullSizeImageUrl, downloadLink: downloadLink_0 })=>{
        await onUnsplashImageClick(fullSizeImageUrl, downloadLink_0);
        coverPictureState.setIsChangingPicture(false);
    }, [
        onUnsplashImageClick,
        coverPictureState
    ]);
    return(// prevent the unsplash search nested popup from closing
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        ref: dropdownRef,
        xcss: $e611c24abe969f89$var$PopupWrapperStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hY5v2.UnsplashSearch), {
        selectedImageUrl: imageSrc,
        imageAltText: imageAltText,
        initialUnsplashResults: initialUnsplashInfoArray,
        idPrefix: "unsplash-popup",
        helperMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e611c24abe969f89$var$i18n.popupTitleLabelSubtext),
        handleImageSelection: handleImageSelection,
        openMediaBrowser: openMediaBrowser,
        sectionLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e611c24abe969f89$var$i18n.popupTitleLabel),
        dropdownPopupComponentRef: dropdownPopupComponentRef,
        isDisabled: userOffline,
        contentId: contentId,
        isPageTitleComponent: isPageTitleComponent,
        isNoImageAllowed: false,
        analyticsSource: "editorPageCoverPicture",
        analyticsActionSubject: "headerImageUpload",
        analyticsActionSubjectId: "headerImageUploadButtonClicked",
        enableBottomSpacing: false
    }), !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && typeof onImageWidthChange === 'function' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98591a14e75c6a83$export$6164b97a36f48473), {
        onImageWidthChange: onImageWidthChange,
        userOffline: userOffline,
        selectedWidth: coverPictureState.state.coverPictureWidth,
        onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected
    }) : null, typeof onReposition === 'function' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$PositionIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kVeP))), {
            label: "",
            spacing: "none"
        })),
        testId: "reposition-image-button",
        isDisabled: userOffline,
        onClick: onReposition,
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$MenuOptionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e611c24abe969f89$var$i18n.repositionButton))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6b4df58911fcb5f7$export$ea36b789677ce46b), {
        generateAIHeaderImage: generateAIHeaderImage,
        deletePreviousHeaderImage: onDelete
    }), typeof onDelete === 'function' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$DeleteButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
            label: ""
        }),
        shouldFitContainer: true,
        onClick: onDelete,
        isDisabled: userOffline,
        testId: "remove-image-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e611c24abe969f89$var$MenuOptionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e611c24abe969f89$var$i18n.removeHeaderButton)))) : null));
};


const $a391e9da6cc7b48e$var$i18n = (0, $cgtv4.defineMessages)({
    headerLabel: {
        id: "content-topper.add.header.image.message.floating-toolbar",
        defaultMessage: "Header image"
    },
    updateImage: {
        id: "content-topper.page-title.popup.update.header.image",
        defaultMessage: "Update header image"
    }
});
const $a391e9da6cc7b48e$export$44d946b74397afda = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { isModalOpenState: isModalOpenState, closePopup: closePopup, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, userOffline: userOffline, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, onAddHeaderImageButtonClicked: onAddHeaderImageButtonClicked, onAddHeaderImageButtonHovered: onAddHeaderImageButtonHovered, onReposition: onReposition, onDelete: onDelete, imageSrc: imageSrc, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, contentId: contentId, generateAIHeaderImage: generateAIHeaderImage } = t0;
    let t1;
    if ($[0] !== closePopup || $[1] !== contentId || $[2] !== coverPictureState || $[3] !== dropdownPopupComponentRef || $[4] !== dropdownRef || $[5] !== generateAIHeaderImage || $[6] !== handleUnsplashUpload || $[7] !== imageSrc || $[8] !== initialUnsplashInfoArray || $[9] !== onDelete || $[10] !== onReposition || $[11] !== openMediaBrowser || $[12] !== setIsUploadingPicture) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e611c24abe969f89$export$5e27412e512156d4), {
                dropdownRef: dropdownRef,
                imageSrc: imageSrc,
                initialUnsplashInfoArray: initialUnsplashInfoArray,
                openMediaBrowser: openMediaBrowser,
                handleUnsplashUpload: handleUnsplashUpload,
                setIsUploadingPicture: setIsUploadingPicture,
                coverPictureState: coverPictureState,
                closePopup: closePopup,
                onReposition: onReposition,
                onDelete: onDelete,
                dropdownPopupComponentRef: dropdownPopupComponentRef,
                contentId: contentId,
                isPageTitleComponent: true,
                generateAIHeaderImage: generateAIHeaderImage
            });
        $[0] = closePopup;
        $[1] = contentId;
        $[2] = coverPictureState;
        $[3] = dropdownPopupComponentRef;
        $[4] = dropdownRef;
        $[5] = generateAIHeaderImage;
        $[6] = handleUnsplashUpload;
        $[7] = imageSrc;
        $[8] = initialUnsplashInfoArray;
        $[9] = onDelete;
        $[10] = onReposition;
        $[11] = openMediaBrowser;
        $[12] = setIsUploadingPicture;
        $[13] = t1;
    } else t1 = $[13];
    let t2;
    if ($[14] !== floatingToolbarButtonStyle || $[15] !== isModalOpenState || $[16] !== onAddHeaderImageButtonClicked || $[17] !== onAddHeaderImageButtonHovered || $[18] !== userOffline) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...triggerProps,
                isSelected: isModalOpenState,
                appearance: "subtle",
                style: floatingToolbarButtonStyle || {},
                testId: "add-header-image-button",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))), {
                    label: ""
                }),
                onClick: onAddHeaderImageButtonClicked,
                isDisabled: userOffline,
                onMouseEnter: onAddHeaderImageButtonHovered
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                className: "add-header-image-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a391e9da6cc7b48e$var$i18n.headerLabel)));
        $[14] = floatingToolbarButtonStyle;
        $[15] = isModalOpenState;
        $[16] = onAddHeaderImageButtonClicked;
        $[17] = onAddHeaderImageButtonHovered;
        $[18] = userOffline;
        $[19] = t2;
    } else t2 = $[19];
    let t3;
    if ($[20] !== closePopup || $[21] !== isModalOpenState || $[22] !== t1 || $[23] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isModalOpenState,
            onClose: closePopup,
            placement: "bottom-start",
            shouldRenderToParent: false,
            content: t1,
            trigger: t2
        });
        $[20] = closePopup;
        $[21] = isModalOpenState;
        $[22] = t1;
        $[23] = t2;
        $[24] = t3;
    } else t3 = $[24];
    return t3;
} : ({ isModalOpenState: isModalOpenState, closePopup: closePopup, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, userOffline: userOffline, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, onAddHeaderImageButtonClicked: onAddHeaderImageButtonClicked, onAddHeaderImageButtonHovered: onAddHeaderImageButtonHovered, onReposition: onReposition, onDelete: onDelete, imageSrc: imageSrc, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, contentId: contentId, generateAIHeaderImage: generateAIHeaderImage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isModalOpenState,
        onClose: closePopup,
        placement: "bottom-start",
        // eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
        shouldRenderToParent: false,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e611c24abe969f89$export$5e27412e512156d4), {
                dropdownRef: dropdownRef,
                imageSrc: imageSrc,
                initialUnsplashInfoArray: initialUnsplashInfoArray,
                openMediaBrowser: openMediaBrowser,
                handleUnsplashUpload: handleUnsplashUpload,
                setIsUploadingPicture: setIsUploadingPicture,
                coverPictureState: coverPictureState,
                closePopup: closePopup,
                onReposition: onReposition,
                onDelete: onDelete,
                dropdownPopupComponentRef: dropdownPopupComponentRef,
                contentId: contentId,
                isPageTitleComponent: true,
                generateAIHeaderImage: generateAIHeaderImage
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...triggerProps,
                isSelected: isModalOpenState,
                appearance: "subtle",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: floatingToolbarButtonStyle || {},
                testId: "add-header-image-button",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))), {
                    label: ""
                }),
                onClick: onAddHeaderImageButtonClicked,
                isDisabled: userOffline,
                onMouseEnter: onAddHeaderImageButtonHovered
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                className: "add-header-image-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a391e9da6cc7b48e$var$i18n.headerLabel)))
    });
};



var $gTAwR = parcelRequire("gTAwR");

const $b276f472a35f7217$var$styles = {
    addHeaderImageButton: "_tzy4kb7n"
};
const $b276f472a35f7217$export$97958e565d90ce0a = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { userOffline: userOffline, openModal: openModal, openMediaBrowser: openMediaBrowser, isModalOpenState: isModalOpenState, closeModal: closeModal, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, initialUnsplashInfoArray: initialUnsplashInfoArray, setInitialUnsplashInfoArray: setInitialUnsplashInfoArray, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, contentId: contentId, generateAIHeaderImage: generateAIHeaderImage } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isPageTitleComponent = true;
    let t1;
    if ($[0] !== initialUnsplashInfoArray.length || $[1] !== setInitialUnsplashInfoArray) {
        t1 = ()=>{
            if (initialUnsplashInfoArray.length === 0) (0, $gTAwR.getUnsplashPhotos)((0, $2Maq7.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD), 1, true).then((results)=>{
                setInitialUnsplashInfoArray(results);
            });
        };
        $[0] = initialUnsplashInfoArray.length;
        $[1] = setInitialUnsplashInfoArray;
        $[2] = t1;
    } else t1 = $[2];
    const onAddHeaderImageButtonHovered = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent || $[4] !== openModal) {
        t2 = ()=>{
            openModal();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "addHeaderImageButtonClicked",
                    source: "editorPageCoverPicture"
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = openModal;
        $[5] = t2;
    } else t2 = $[5];
    const onAddHeaderImageButtonClicked = t2;
    let t3;
    if ($[6] !== coverPictureState || $[7] !== isModalOpenState) {
        t3 = ()=>{
            if (!isModalOpenState) coverPictureState.setIsAddHeaderImageButtonFocused(true);
        };
        $[6] = coverPictureState;
        $[7] = isModalOpenState;
        $[8] = t3;
    } else t3 = $[8];
    const handleFocus = t3;
    let t4;
    if ($[9] !== coverPictureState) {
        t4 = ()=>{
            coverPictureState.setIsAddHeaderImageButtonFocused(false);
        };
        $[9] = coverPictureState;
        $[10] = t4;
    } else t4 = $[10];
    const handleBlur = t4;
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $gMc0m.default)([
            $b276f472a35f7217$var$styles.addHeaderImageButton
        ]);
        $[11] = t5;
    } else t5 = $[11];
    const t6 = initialUnsplashInfoArray;
    let t7;
    if ($[12] !== closeModal || $[13] !== contentId || $[14] !== coverPictureState || $[15] !== floatingToolbarButtonStyle || $[16] !== generateAIHeaderImage || $[17] !== handleUnsplashUpload || $[18] !== isModalOpenState || $[19] !== onAddHeaderImageButtonClicked || $[20] !== onAddHeaderImageButtonHovered || $[21] !== openMediaBrowser || $[22] !== setIsUploadingPicture || $[23] !== t6 || $[24] !== userOffline) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a391e9da6cc7b48e$export$44d946b74397afda), {
            imageSrc: "",
            initialUnsplashInfoArray: t6,
            openMediaBrowser: openMediaBrowser,
            handleUnsplashUpload: handleUnsplashUpload,
            setIsUploadingPicture: setIsUploadingPicture,
            coverPictureState: coverPictureState,
            closePopup: closeModal,
            userOffline: userOffline,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            isModalOpenState: isModalOpenState,
            onAddHeaderImageButtonClicked: onAddHeaderImageButtonClicked,
            onAddHeaderImageButtonHovered: onAddHeaderImageButtonHovered,
            contentId: contentId,
            generateAIHeaderImage: generateAIHeaderImage
        });
        $[12] = closeModal;
        $[13] = contentId;
        $[14] = coverPictureState;
        $[15] = floatingToolbarButtonStyle;
        $[16] = generateAIHeaderImage;
        $[17] = handleUnsplashUpload;
        $[18] = isModalOpenState;
        $[19] = onAddHeaderImageButtonClicked;
        $[20] = onAddHeaderImageButtonHovered;
        $[21] = openMediaBrowser;
        $[22] = setIsUploadingPicture;
        $[23] = t6;
        $[24] = userOffline;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== handleBlur || $[27] !== handleFocus || $[28] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "add-header-image-button-wrapper",
            onFocus: handleFocus,
            onBlur: handleBlur,
            className: t5
        }, t7);
        $[26] = handleBlur;
        $[27] = handleFocus;
        $[28] = t7;
        $[29] = t8;
    } else t8 = $[29];
    return t8;
} : ({ userOffline: userOffline, openModal: openModal, openMediaBrowser: openMediaBrowser, isModalOpenState: isModalOpenState, closeModal: closeModal, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, initialUnsplashInfoArray: initialUnsplashInfoArray, setInitialUnsplashInfoArray: setInitialUnsplashInfoArray, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, contentId: contentId, generateAIHeaderImage: generateAIHeaderImage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isPageTitleComponent = true;
    const onAddHeaderImageButtonHovered = (0, $42omo.useCallback)(()=>{
        if (initialUnsplashInfoArray.length === 0) (0, $gTAwR.getUnsplashPhotos)((0, $2Maq7.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD), 1, isPageTitleComponent).then((results)=>{
            setInitialUnsplashInfoArray(results);
        });
    }, [
        initialUnsplashInfoArray,
        isPageTitleComponent,
        setInitialUnsplashInfoArray
    ]);
    const onAddHeaderImageButtonClicked = ()=>{
        openModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'addHeaderImageButtonClicked',
                source: 'editorPageCoverPicture'
            }
        }).fire();
    };
    const handleFocus = (0, $42omo.useCallback)(()=>{
        if (!isModalOpenState) coverPictureState.setIsAddHeaderImageButtonFocused(true);
    }, [
        isModalOpenState,
        coverPictureState
    ]);
    const handleBlur = (0, $42omo.useCallback)(()=>{
        coverPictureState.setIsAddHeaderImageButtonFocused(false);
    }, [
        coverPictureState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "add-header-image-button-wrapper",
        onFocus: handleFocus,
        onBlur: handleBlur,
        className: (0, $gMc0m.default)([
            $b276f472a35f7217$var$styles.addHeaderImageButton
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a391e9da6cc7b48e$export$44d946b74397afda), {
        imageSrc: "",
        initialUnsplashInfoArray: initialUnsplashInfoArray,
        openMediaBrowser: openMediaBrowser,
        handleUnsplashUpload: handleUnsplashUpload,
        setIsUploadingPicture: setIsUploadingPicture,
        coverPictureState: coverPictureState,
        closePopup: closeModal,
        userOffline: userOffline,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        isModalOpenState: isModalOpenState,
        onAddHeaderImageButtonClicked: onAddHeaderImageButtonClicked,
        onAddHeaderImageButtonHovered: onAddHeaderImageButtonHovered,
        contentId: contentId,
        generateAIHeaderImage: generateAIHeaderImage
    }));
};

































const $46b253a18b421305$var$i18n = (0, $cgtv4.defineMessages)({
    dragToReposition: {
        id: "page-cover-picture.drag.to.reposition.message",
        defaultMessage: "Drag to reposition"
    },
    saveReposition: {
        id: "page-cover-picture.save.reposition",
        defaultMessage: "Apply"
    },
    cancelReposition: {
        id: "page-cover-picture.cancel.reposition",
        defaultMessage: "Cancel"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46b253a18b421305$var$RepositionWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { userOffline: userOffline, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q7i8nm _1e0c1txw _4cvr1h6o _3um0ewfl _4t3i1ul9 _1bsb1osq",
            __cmplp.userOffline ? "_80om13gf" : "_80om73ad",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { userOffline: userOffline, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7i8nm _1e0c1txw _4cvr1h6o _3um0ewfl _4t3i1ul9 _1bsb1osq",
            __cmplp.userOffline ? "_80om13gf" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $46b253a18b421305$var$DragToRepositionTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c81ixg _syaz1j9a _1e0c1txw _1bsb1t1y _1bahesu3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81ixg _syaz1j9a _1e0c1txw _1bsb1t1y _1bahesu3",
            __cmplp.className
        ])
    });
});
const $46b253a18b421305$var$RepositionButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c82smr _syazi7uo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _syazi7uo",
            __cmplp.className
        ])
    });
});
const $46b253a18b421305$var$RepositionButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1lk2 _1e0c1txw _1bahesu3 _2hwxu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1lk2 _1e0c1txw _1bahesu3 _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $46b253a18b421305$var$RepositionImageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "span" : t2;
        const { userOffline: userOffline, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1isxe5u": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_kqswh2mm _4t3i1v90 _1bsb1osq _1e0c1txw _4cvr1y6m",
                __cmplp.userOffline ? "_80om13gf" : "_80ommivt",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { userOffline: userOffline, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1isxe5u": (0, $7sObp.default)(`${__cmplp.dynamicCoverImageHeight}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _4t3i1v90 _1bsb1osq _1e0c1txw _4cvr1y6m",
            __cmplp.userOffline ? "_80om13gf" : "_80ommivt",
            __cmplp.className
        ])
    });
});
const $46b253a18b421305$export$78e1d98d4f84631f = ({ initialPicturePosition: initialPicturePosition, onSaveReposition: onSaveReposition, setIsRepositionActive: setIsRepositionActive, setShouldShowReposition: setShouldShowReposition, coverPictureState: coverPictureState, forceUpdate: forceUpdate, userOffline: userOffline, dynamicCoverImageHeight: dynamicCoverImageHeight })=>{
    const userOfflineRef = (0, $42omo.useRef)(userOffline);
    (0, $42omo.useEffect)(()=>{
        userOfflineRef.current = userOffline;
    }, [
        userOffline
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const handleRepositionImageMouseDown = ()=>{
        // if we are here that means reposition is active since the div is visible to the user and user just moused down inside the image
        // they want to reposition
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    const handleMouseUp = ()=>{
        removeListeners();
    };
    let oldClientY = 0;
    const curPos = (0, $42omo.useRef)(initialPicturePosition || (0, $75Ax4.DEFAULT_POSITION_VALUE));
    const handleMouseMove = (e)=>{
        if (userOfflineRef.current) {
            removeListeners();
            return;
        }
        e.preventDefault();
        // prevent text selection
        const img = document.getElementById('actual-cover-picture');
        if (e.clientY > oldClientY) // mouse moved down
        {
            if (curPos.current - 0.75 >= 0) {
                curPos.current -= 0.75;
                img.style.objectPosition = `center ${curPos.current}%`;
            }
        } else if (e.clientY < oldClientY) // mouse moved up
        {
            if (curPos.current + 0.75 <= 100) {
                curPos.current += 0.75;
                img.style.objectPosition = `center ${curPos.current}%`;
            }
        }
        oldClientY = e.clientY;
    };
    const removeListeners = ()=>{
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };
    const saveReposition = async ()=>{
        coverPictureState.setIsRepositioningPicture(true);
        await onSaveReposition(curPos.current);
        setIsRepositionActive(false);
        setShouldShowReposition(false);
        coverPictureState.setIsRepositioningPicture(false);
        removeListeners();
        await coverPictureState.setIsChangingPicture(false);
        await coverPictureState.setShouldShowReposition(false);
        forceUpdate?.(Math.random());
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'repositionSaveButtonClicked',
                source: 'editorPageCoverPicture',
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
    };
    const cancelReposition = async ()=>{
        const img_0 = document.getElementById('actual-cover-picture');
        setIsRepositionActive(false);
        setShouldShowReposition(false);
        coverPictureState.setIsRepositioningPicture(false);
        removeListeners();
        await coverPictureState.setShouldShowReposition(false);
        await coverPictureState.setIsChangingPicture(false);
        forceUpdate?.(Math.random());
        if (img_0) img_0.style.objectPosition = `center ${initialPicturePosition}%`;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'repositionCancelButtonClicked',
                source: 'editorPageCoverPicture'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$RepositionImageWrapper, {
        onMouseDown: userOffline ? undefined : handleRepositionImageMouseDown,
        "data-testid": "reposition-div",
        userOffline: userOffline,
        dynamicCoverImageHeight: dynamicCoverImageHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$RepositionWrapper, {
        userOffline: userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$DragToRepositionTextWrapper, null, formatMessage($46b253a18b421305$var$i18n.dragToReposition)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$RepositionButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "save-reposition-button",
        spacing: "compact",
        onClick: saveReposition,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            background: "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginRight: "var(--ds-space-200, 16px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginLeft: "var(--ds-space-negative-100, -8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-025, 2px)"
        },
        isDisabled: userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$RepositionButtonText, null, formatMessage($46b253a18b421305$var$i18n.saveReposition))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "cancel-reposition-button",
        spacing: "compact",
        onClick: cancelReposition,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            background: "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-025, 2px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginLeft: "var(--ds-space-negative-050, -4px)"
        },
        isDisabled: userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46b253a18b421305$var$RepositionButtonText, null, formatMessage($46b253a18b421305$var$i18n.cancelReposition))))));
};


























































const $1bbfbc20e55661d7$var$i18n = (0, $cgtv4.defineMessages)({
    headerLabel: {
        id: "content-topper.add.header.image.message.floating-toolbar",
        defaultMessage: "Header image"
    },
    updateImage: {
        id: "content-topper.page-title.popup.update.header.image",
        defaultMessage: "Update header image"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1bbfbc20e55661d7$var$DropdownTrigger = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        const { userOffline: userOffline, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2lx21bp4 _1n261q9c _11q7glyw _19itglyw _1e0c1txw _4cvr1h6o _syaz1j9a _12jivbh5",
            __cmplp.userOffline ? "_80om13gf" : "_80omtlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { userOffline: userOffline, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx21bp4 _1n261q9c _11q7glyw _19itglyw _1e0c1txw _4cvr1h6o _syaz1j9a _12jivbh5",
            __cmplp.userOffline ? "_80om13gf" : "_80omtlke",
            __cmplp.className
        ])
    });
});
const $1bbfbc20e55661d7$export$f190f045ee817cbf = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { isModalOpenState: isModalOpenState, closePopup: closePopup, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, userOffline: userOffline, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, onReposition: onReposition, onDelete: onDelete, imageSrc: imageSrc, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, contentId: contentId, onImageWidthChange: onImageWidthChange, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected, generateAIHeaderImage: generateAIHeaderImage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $dTk3A.layers).dialog();
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== floatingToolbarButtonStyle || $[2] !== isModalOpenState || $[3] !== userOffline) {
        t2 = (t3)=>{
            const { triggerRef: triggerRef, ...props } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1bbfbc20e55661d7$var$DropdownTrigger, {
                "data-testid": "update-image-button",
                ...props,
                tabIndex: 0,
                "aria-expanded": isModalOpenState,
                ref: triggerRef,
                style: floatingToolbarButtonStyle || {},
                userOffline: userOffline,
                disabled: userOffline
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))), {
                label: "",
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $1bbfbc20e55661d7$var$i18n.updateImage));
        };
        $[1] = floatingToolbarButtonStyle;
        $[2] = isModalOpenState;
        $[3] = userOffline;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== closePopup || $[6] !== contentId || $[7] !== coverPictureState || $[8] !== dropdownPopupComponentRef || $[9] !== dropdownRef || $[10] !== generateAIHeaderImage || $[11] !== handleUnsplashUpload || $[12] !== imageSrc || $[13] !== initialUnsplashInfoArray || $[14] !== onCoverImageWidthDropdownOptionSelected || $[15] !== onDelete || $[16] !== onImageWidthChange || $[17] !== onReposition || $[18] !== openMediaBrowser || $[19] !== setIsUploadingPicture || $[20] !== userOffline) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e611c24abe969f89$export$5e27412e512156d4), {
            dropdownRef: dropdownRef,
            contentId: contentId,
            imageSrc: imageSrc,
            initialUnsplashInfoArray: initialUnsplashInfoArray,
            openMediaBrowser: openMediaBrowser,
            handleUnsplashUpload: handleUnsplashUpload,
            setIsUploadingPicture: setIsUploadingPicture,
            coverPictureState: coverPictureState,
            closePopup: closePopup,
            onReposition: onReposition,
            onDelete: onDelete,
            placement: "bottom",
            userOffline: userOffline,
            dropdownPopupComponentRef: dropdownPopupComponentRef,
            onImageWidthChange: onImageWidthChange,
            isPageTitleComponent: true,
            onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected,
            generateAIHeaderImage: generateAIHeaderImage
        });
        $[5] = closePopup;
        $[6] = contentId;
        $[7] = coverPictureState;
        $[8] = dropdownPopupComponentRef;
        $[9] = dropdownRef;
        $[10] = generateAIHeaderImage;
        $[11] = handleUnsplashUpload;
        $[12] = imageSrc;
        $[13] = initialUnsplashInfoArray;
        $[14] = onCoverImageWidthDropdownOptionSelected;
        $[15] = onDelete;
        $[16] = onImageWidthChange;
        $[17] = onReposition;
        $[18] = openMediaBrowser;
        $[19] = setIsUploadingPicture;
        $[20] = userOffline;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== isModalOpenState || $[23] !== t2 || $[24] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            defaultOpen: false,
            isOpen: isModalOpenState,
            placement: "bottom",
            zIndex: t1,
            strategy: "absolute",
            shouldRenderToParent: true,
            trigger: t2
        }, t3);
        $[22] = isModalOpenState;
        $[23] = t2;
        $[24] = t3;
        $[25] = t4;
    } else t4 = $[25];
    return t4;
} : ({ isModalOpenState: isModalOpenState, closePopup: closePopup, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, userOffline: userOffline, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, onReposition: onReposition, onDelete: onDelete, imageSrc: imageSrc, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, contentId: contentId, onImageWidthChange: onImageWidthChange, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected, generateAIHeaderImage: generateAIHeaderImage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        defaultOpen: false,
        isOpen: isModalOpenState,
        placement: "bottom",
        zIndex: (0, $dTk3A.layers).dialog(),
        strategy: "absolute",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1bbfbc20e55661d7$var$DropdownTrigger, {
                "data-testid": "update-image-button",
                ...props,
                tabIndex: 0,
                "aria-expanded": isModalOpenState,
                ref: triggerRef,
                style: floatingToolbarButtonStyle || {},
                userOffline: userOffline,
                disabled: userOffline
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))), {
                label: "",
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $1bbfbc20e55661d7$var$i18n.updateImage))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e611c24abe969f89$export$5e27412e512156d4), {
        dropdownRef: dropdownRef,
        contentId: contentId,
        imageSrc: imageSrc,
        initialUnsplashInfoArray: initialUnsplashInfoArray,
        openMediaBrowser: openMediaBrowser,
        handleUnsplashUpload: handleUnsplashUpload,
        setIsUploadingPicture: setIsUploadingPicture,
        coverPictureState: coverPictureState,
        closePopup: closePopup,
        onReposition: onReposition,
        onDelete: onDelete,
        placement: "bottom",
        userOffline: userOffline,
        dropdownPopupComponentRef: dropdownPopupComponentRef,
        onImageWidthChange: onImageWidthChange,
        isPageTitleComponent: true,
        onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected,
        generateAIHeaderImage: generateAIHeaderImage
    }));
};





const $d56946553982f95c$var$COVER_IMAGE_FIXED_HEIGHT = 147; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d56946553982f95c$var$HoverOverlay = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, userOffline: userOffline, isDropdownOpen: isDropdownOpen, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_pjvxvw": (0, $7sObp.default)(__cmplp.dynamicCoverImageHeight, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q7plhp _2rkofajl _1bsb1osq _kqswh2mm _1e0c1txw _1bah1h6o _4cvr1h6o",
                __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : !__cmplp.isFixedWidthImageOption ? "_4t3i6w0c" : "_4t3ifmv9",
                __cmplp.userOffline ? "_80om13gf" : "_80omtlke",
                __cmplp.isDropdownOpen ? "_tzy4kb7n" : "_tzy4idpf",
                __cmplp.userOffline ? "_16l4idpf" : "_16l4kb7n",
                __cmplp.userOffline ? "_1mygidpf" : "_1mygkb7n",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, userOffline: userOffline, isDropdownOpen: isDropdownOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_pjvxvw": (0, $7sObp.default)(__cmplp.dynamicCoverImageHeight, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7plhp _2rkofajl _1bsb1osq _kqswh2mm _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : !__cmplp.isFixedWidthImageOption ? "_4t3i6w0c" : "_4t3ifmv9",
            __cmplp.userOffline ? "_80om13gf" : "_80omtlke",
            __cmplp.isDropdownOpen ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.userOffline ? "_16l4idpf" : "_16l4kb7n",
            __cmplp.userOffline ? "_1mygidpf" : "_1mygkb7n",
            __cmplp.className
        ])
    });
});
const $d56946553982f95c$export$d83b52f1c3c4071e = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(50);
    const { userOffline: userOffline, closeModal: closeModal, openMediaBrowser: openMediaBrowser, setIsRepositionActive: setIsRepositionActive, onRemoveImage: onRemoveImage, onImageWidthChange: onImageWidthChange, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, initialUnsplashInfoArray: initialUnsplashInfoArray, setInitialUnsplashInfoArray: setInitialUnsplashInfoArray, coverPictureState: coverPictureState, contentId: contentId, dynamicCoverImageHeight: dynamicCoverImageHeight, isFixedWidthImageOption: isFixedWidthImageOption, generateAIHeaderImage: generateAIHeaderImage } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const overlayComponent = (0, $42omo.useRef)(null);
    const dropdownComponent = (0, $42omo.useRef)(null);
    const dropdownPopupComponentRef = (0, $42omo.useRef)(null);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t1;
    if ($[0] !== coverPictureState) {
        t1 = (event)=>{
            if (overlayComponent?.current && event.target instanceof Node && !overlayComponent?.current?.contains(event.target) && !dropdownComponent?.current?.contains(event.target) && !dropdownPopupComponentRef?.current?.contains(event.target) && coverPictureState.state.isChangingPicture) {
                coverPictureState.setIsChangingPicture(false);
                setIsDropdownOpen(false);
            }
        };
        $[0] = coverPictureState;
        $[1] = t1;
    } else t1 = $[1];
    const handleClickOutside = t1;
    let t2;
    let t3;
    if ($[2] !== handleClickOutside) {
        t2 = ()=>{
            addEventListener("mousedown", handleClickOutside);
            return ()=>{
                document.removeEventListener("mousedown", handleClickOutside);
            };
        };
        t3 = [
            handleClickOutside
        ];
        $[2] = handleClickOutside;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[5] !== coverPictureState || $[6] !== createAnalyticsEvent || $[7] !== initialUnsplashInfoArray || $[8] !== isLivePage || $[9] !== setInitialUnsplashInfoArray) {
        t4 = (event_0)=>{
            if (event_0.target instanceof Node && (dropdownComponent?.current?.contains(event_0.target) || dropdownPopupComponentRef?.current?.contains(event_0.target))) return;
            if (initialUnsplashInfoArray.length === 0) (0, $gTAwR.getUnsplashPhotos)((0, $2Maq7.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD), 1, true).then((results)=>{
                setInitialUnsplashInfoArray(results);
            });
            const isChangingPicture = coverPictureState.state.isChangingPicture;
            coverPictureState.setIsChangingPicture(!isChangingPicture);
            setIsDropdownOpen($d56946553982f95c$var$_temp);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "update",
                    actionSubjectId: "updateHeaderImageButtonClicked",
                    source: "editorPageCoverPicture",
                    attributes: {
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        $[5] = coverPictureState;
        $[6] = createAnalyticsEvent;
        $[7] = initialUnsplashInfoArray;
        $[8] = isLivePage;
        $[9] = setInitialUnsplashInfoArray;
        $[10] = t4;
    } else t4 = $[10];
    const toggleDropdownOpen = t4;
    let t5;
    if ($[11] !== coverPictureState || $[12] !== createAnalyticsEvent || $[13] !== setIsRepositionActive) {
        t5 = ()=>{
            setIsRepositionActive(true);
            coverPictureState.setIsChangingPicture(false);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "reposition",
                    actionSubjectId: "repositionHeaderImageButtonClicked",
                    source: "editorPageCoverPicture"
                }
            }).fire();
        };
        $[11] = coverPictureState;
        $[12] = createAnalyticsEvent;
        $[13] = setIsRepositionActive;
        $[14] = t5;
    } else t5 = $[14];
    const onRepositionClicked = t5;
    let t6;
    if ($[15] !== createAnalyticsEvent || $[16] !== experienceTracker || $[17] !== isLivePage || $[18] !== onRemoveImage) {
        t6 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.COVER_PICTURE_REMOVE_EXPERIENCE)
            });
            onRemoveImage();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "remove",
                    actionSubjectId: "removeHeaderImageButtonClicked",
                    source: "editorPageCoverPicture",
                    attributes: {
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        $[15] = createAnalyticsEvent;
        $[16] = experienceTracker;
        $[17] = isLivePage;
        $[18] = onRemoveImage;
        $[19] = t6;
    } else t6 = $[19];
    const onRemoveImageClicked = t6;
    let t7;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (isCoverImageWidthChanged)=>{
            if (isCoverImageWidthChanged) setIsDropdownOpen(false);
        };
        $[20] = t7;
    } else t7 = $[20];
    const onCoverImageWidthDropdownOptionSelected = t7;
    let t8;
    if ($[21] !== coverPictureState) {
        t8 = ()=>{
            coverPictureState.setIsAddHeaderImageButtonFocused(true);
        };
        $[21] = coverPictureState;
        $[22] = t8;
    } else t8 = $[22];
    const handleFocus = t8;
    let t9;
    if ($[23] !== coverPictureState) {
        t9 = ()=>{
            coverPictureState.setIsAddHeaderImageButtonFocused(false);
        };
        $[23] = coverPictureState;
        $[24] = t9;
    } else t9 = $[24];
    const handleBlur = t9;
    const t10 = userOffline ? undefined : toggleDropdownOpen;
    let t11;
    if ($[25] !== closeModal || $[26] !== contentId || $[27] !== coverPictureState || $[28] !== generateAIHeaderImage || $[29] !== handleUnsplashUpload || $[30] !== initialUnsplashInfoArray || $[31] !== isDropdownOpen || $[32] !== onImageWidthChange || $[33] !== onRemoveImageClicked || $[34] !== onRepositionClicked || $[35] !== openMediaBrowser || $[36] !== setIsUploadingPicture || $[37] !== userOffline) {
        t11 = !userOffline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1bbfbc20e55661d7$export$f190f045ee817cbf), {
            dropdownRef: dropdownComponent,
            onDelete: onRemoveImageClicked,
            onReposition: onRepositionClicked,
            imageSrc: coverPictureState.state.coverPictureId,
            isModalOpenState: isDropdownOpen,
            openMediaBrowser: openMediaBrowser,
            initialUnsplashInfoArray: initialUnsplashInfoArray,
            closePopup: closeModal,
            userOffline: userOffline,
            handleUnsplashUpload: handleUnsplashUpload,
            setIsUploadingPicture: setIsUploadingPicture,
            coverPictureState: coverPictureState,
            dropdownPopupComponentRef: dropdownPopupComponentRef,
            contentId: contentId,
            onImageWidthChange: onImageWidthChange,
            onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected,
            generateAIHeaderImage: generateAIHeaderImage
        });
        $[25] = closeModal;
        $[26] = contentId;
        $[27] = coverPictureState;
        $[28] = generateAIHeaderImage;
        $[29] = handleUnsplashUpload;
        $[30] = initialUnsplashInfoArray;
        $[31] = isDropdownOpen;
        $[32] = onImageWidthChange;
        $[33] = onRemoveImageClicked;
        $[34] = onRepositionClicked;
        $[35] = openMediaBrowser;
        $[36] = setIsUploadingPicture;
        $[37] = userOffline;
        $[38] = t11;
    } else t11 = $[38];
    let t12;
    if ($[39] !== dynamicCoverImageHeight || $[40] !== isDropdownOpen || $[41] !== isFixedWidthImageOption || $[42] !== t10 || $[43] !== t11 || $[44] !== userOffline) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d56946553982f95c$var$HoverOverlay, {
            "data-testid": "hover-overlay-custom-sites",
            isDropdownOpen: isDropdownOpen,
            onClick: t10,
            ref: overlayComponent,
            userOffline: userOffline,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            isFixedWidthImageOption: isFixedWidthImageOption,
            className: "cover-picture-wrapper-dangerously-set-inner-html"
        }, t11);
        $[39] = dynamicCoverImageHeight;
        $[40] = isDropdownOpen;
        $[41] = isFixedWidthImageOption;
        $[42] = t10;
        $[43] = t11;
        $[44] = userOffline;
        $[45] = t12;
    } else t12 = $[45];
    let t13;
    if ($[46] !== handleBlur || $[47] !== handleFocus || $[48] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onFocus: handleFocus,
            onBlur: handleBlur
        }, t12);
        $[46] = handleBlur;
        $[47] = handleFocus;
        $[48] = t12;
        $[49] = t13;
    } else t13 = $[49];
    return t13;
} : ({ userOffline: userOffline, closeModal: closeModal, openMediaBrowser: openMediaBrowser, setIsRepositionActive: setIsRepositionActive, onRemoveImage: onRemoveImage, onImageWidthChange: onImageWidthChange, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, initialUnsplashInfoArray: initialUnsplashInfoArray, setInitialUnsplashInfoArray: setInitialUnsplashInfoArray, coverPictureState: coverPictureState, contentId: contentId, dynamicCoverImageHeight: dynamicCoverImageHeight, isFixedWidthImageOption: isFixedWidthImageOption, generateAIHeaderImage: generateAIHeaderImage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const overlayComponent = (0, $42omo.useRef)(null);
    const dropdownComponent = (0, $42omo.useRef)(null);
    const dropdownPopupComponentRef = (0, $42omo.useRef)(null);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const handleClickOutside = (0, $42omo.useCallback)((event)=>{
        if (overlayComponent?.current && event.target instanceof Node && !overlayComponent?.current?.contains(event.target) && !dropdownComponent?.current?.contains(event.target) && !dropdownPopupComponentRef?.current?.contains(event.target) && // only invoke a change if the user is changing the picture.
        // If we keep updating the state to the same value in an unstated container, it will invoke re-renders of all title components.
        coverPictureState.state.isChangingPicture) {
            // close parent dropdown if we click anywhere outside
            coverPictureState.setIsChangingPicture(false);
            setIsDropdownOpen(false);
        }
    }, [
        coverPictureState
    ]); // took inspiration from here:
    // https://bitbucket.org/atlassian/ptc-directory-ui/src/84f964d666578de7d67d99727c734e1231b8588c/packages/common/src/components/ProfileHeader/ProfileHeader.tsx?at=master#lines-83
    // basically if we click outside of the hover overlay, close the dropdown
    (0, $42omo.useEffect)(()=>{
        addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    const toggleDropdownOpen = (0, $42omo.useCallback)((event_0)=>{
        if (event_0.target instanceof Node && (dropdownComponent?.current?.contains(event_0.target) || dropdownPopupComponentRef?.current?.contains(event_0.target))) // don't toggle close the dropdown if clicking in the dropdown
        // we need this since the popup is nested
        return;
        if (initialUnsplashInfoArray.length === 0) (0, $gTAwR.getUnsplashPhotos)((0, $2Maq7.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD), 1, true).then((results)=>{
            setInitialUnsplashInfoArray(results);
        });
        const isChangingPicture = coverPictureState.state.isChangingPicture;
        coverPictureState.setIsChangingPicture(!isChangingPicture);
        setIsDropdownOpen((prevIsDropdownOpen)=>!prevIsDropdownOpen);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'update',
                actionSubjectId: 'updateHeaderImageButtonClicked',
                source: 'editorPageCoverPicture',
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        initialUnsplashInfoArray,
        setInitialUnsplashInfoArray,
        createAnalyticsEvent,
        isLivePage,
        coverPictureState
    ]);
    const onRepositionClicked = ()=>{
        setIsRepositionActive(true);
        coverPictureState.setIsChangingPicture(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'reposition',
                actionSubjectId: 'repositionHeaderImageButtonClicked',
                source: 'editorPageCoverPicture'
            }
        }).fire();
    };
    const onRemoveImageClicked = ()=>{
        experienceTracker.start({
            name: (0, $irVI7.COVER_PICTURE_REMOVE_EXPERIENCE)
        });
        onRemoveImage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'remove',
                actionSubjectId: 'removeHeaderImageButtonClicked',
                source: 'editorPageCoverPicture',
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
    };
    const onCoverImageWidthDropdownOptionSelected = (isCoverImageWidthChanged)=>{
        if (isCoverImageWidthChanged) setIsDropdownOpen(false);
    };
    const handleFocus = (0, $42omo.useCallback)(()=>{
        coverPictureState.setIsAddHeaderImageButtonFocused(true);
    }, [
        coverPictureState
    ]);
    const handleBlur = (0, $42omo.useCallback)(()=>{
        coverPictureState.setIsAddHeaderImageButtonFocused(false);
    }, [
        coverPictureState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d56946553982f95c$var$HoverOverlay, {
        "data-testid": "hover-overlay-custom-sites",
        isDropdownOpen: isDropdownOpen,
        onClick: userOffline ? undefined : toggleDropdownOpen,
        ref: overlayComponent,
        userOffline: userOffline,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isFixedWidthImageOption: isFixedWidthImageOption,
        className: "cover-picture-wrapper-dangerously-set-inner-html"
    }, !userOffline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1bbfbc20e55661d7$export$f190f045ee817cbf), {
        dropdownRef: dropdownComponent,
        onDelete: onRemoveImageClicked,
        onReposition: onRepositionClicked,
        imageSrc: coverPictureState.state.coverPictureId,
        isModalOpenState: isDropdownOpen,
        openMediaBrowser: openMediaBrowser,
        initialUnsplashInfoArray: initialUnsplashInfoArray,
        closePopup: closeModal,
        userOffline: userOffline,
        handleUnsplashUpload: handleUnsplashUpload,
        setIsUploadingPicture: setIsUploadingPicture,
        coverPictureState: coverPictureState,
        dropdownPopupComponentRef: dropdownPopupComponentRef,
        contentId: contentId,
        onImageWidthChange: onImageWidthChange,
        onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected,
        generateAIHeaderImage: generateAIHeaderImage
    })));
};
function $d56946553982f95c$var$_temp(prevIsDropdownOpen) {
    return !prevIsDropdownOpen;
}

















var $6f0Oj = parcelRequire("6f0Oj");







var $imt6g = parcelRequire("imt6g");


var $d8ohW = parcelRequire("d8ohW");




const $ba41bcbf59914f9a$var$aiUnsplashHeaderToolbar = (0, $ecnYn.xcss)({
    // @ts-expect-error
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    right: '20px',
    bottom: '20px',
    borderRadius: 'radius.medium',
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    zIndex: '1'
});
const $ba41bcbf59914f9a$var$separatorStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-border, #0B120E24)",
    width: '1px',
    height: '20px',
    display: 'inline-block',
    marginInline: 'space.100',
    userSelect: 'none'
});
const $ba41bcbf59914f9a$var$seperator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
    xcss: $ba41bcbf59914f9a$var$separatorStyles
});
const $ba41bcbf59914f9a$var$i18n = (0, $cgtv4.defineMessages)({
    acceptLabel: {
        id: "page-cover-picture.ai-unsplash-toolbar.accept",
        defaultMessage: "Accept image"
    },
    regenerateLabel: {
        id: "page-cover-picture.ai-unsplash-toolbar.regenerate",
        defaultMessage: "Regenerate image"
    },
    removeLabel: {
        id: "page-cover-picture.ai-unsplash-toolbar.remove",
        defaultMessage: "Remove image"
    }
});
const $ba41bcbf59914f9a$export$f3c1fc220041ced8 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { onAccept: onAccept, onRegenerate: onRegenerate, onRemoveImage: onRemoveImage, isRegeneratingImage: isRegeneratingImage } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($ba41bcbf59914f9a$var$i18n.acceptLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onAccept || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            onClick: onAccept,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($imt6g))),
            appearance: "subtle",
            spacing: "compact",
            testId: "AIUnsplashHeaderToolbar-accept",
            label: t1
        });
        $[2] = onAccept;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = !isRegeneratingImage ? onRegenerate : undefined;
    let t4;
    if ($[5] !== formatMessage) {
        t4 = formatMessage($ba41bcbf59914f9a$var$i18n.regenerateLabel);
        $[5] = formatMessage;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isRegeneratingImage || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            onClick: t3,
            isLoading: isRegeneratingImage,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))),
            appearance: "subtle",
            spacing: "compact",
            testId: "AIUnsplashHeaderToolbar-regenerate",
            label: t4
        });
        $[7] = isRegeneratingImage;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== formatMessage) {
        t6 = formatMessage($ba41bcbf59914f9a$var$i18n.removeLabel);
        $[11] = formatMessage;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== onRemoveImage || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            onClick: onRemoveImage,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
            appearance: "subtle",
            spacing: "compact",
            testId: "AIUnsplashHeaderToolbar-remove",
            label: t6
        });
        $[13] = onRemoveImage;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t2 || $[17] !== t5 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $ba41bcbf59914f9a$var$aiUnsplashHeaderToolbar,
            testId: "AIUnsplashHeaderToolbar"
        }, t2, $ba41bcbf59914f9a$var$seperator, t5, $ba41bcbf59914f9a$var$seperator, t7);
        $[16] = t2;
        $[17] = t5;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ onAccept: onAccept, onRegenerate: onRegenerate, onRemoveImage: onRemoveImage, isRegeneratingImage: isRegeneratingImage })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ba41bcbf59914f9a$var$aiUnsplashHeaderToolbar,
        testId: "AIUnsplashHeaderToolbar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: onAccept,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($imt6g))),
        appearance: "subtle",
        spacing: "compact",
        testId: "AIUnsplashHeaderToolbar-accept",
        label: formatMessage($ba41bcbf59914f9a$var$i18n.acceptLabel)
    }), $ba41bcbf59914f9a$var$seperator, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: !isRegeneratingImage ? onRegenerate : undefined,
        isLoading: isRegeneratingImage,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))),
        appearance: "subtle",
        spacing: "compact",
        testId: "AIUnsplashHeaderToolbar-regenerate",
        label: formatMessage($ba41bcbf59914f9a$var$i18n.regenerateLabel)
    }), $ba41bcbf59914f9a$var$seperator, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: onRemoveImage,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        appearance: "subtle",
        spacing: "compact",
        testId: "AIUnsplashHeaderToolbar-remove",
        label: formatMessage($ba41bcbf59914f9a$var$i18n.removeLabel)
    }));
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $689140bd887be349$var$UploadingPictureWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1isxe5u": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q7ysee _2rkofajl _1bsb1osq _4t3i1v90 _kqswh2mm _1e0c1txw _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1isxe5u": (0, $7sObp.default)(`${__cmplp.dynamicCoverImageHeight}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7ysee _2rkofajl _1bsb1osq _4t3i1v90 _kqswh2mm _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $689140bd887be349$export$4103f8c62b69a0b3 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(50);
    const { hasCoverPicture: hasCoverPicture, openMediaBrowser: openMediaBrowser, onRemoveImage: onRemoveImage, userOffline: userOffline, setIsUploadingPicture: setIsUploadingPicture, isUploadingPicture: isUploadingPicture, handleUnsplashUpload: handleUnsplashUpload, initialPicturePosition: initialPicturePosition, onSaveReposition: onSaveReposition, shouldShowReposition: shouldShowReposition, setShouldShowReposition: setShouldShowReposition, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, forceUpdate: forceUpdate, contentId: contentId, dynamicCoverImageHeight: dynamicCoverImageHeight, onImageWidthChange: onImageWidthChange, spaceKey: spaceKey, onRegenerate: onRegenerate, isRegeneratingImage: isRegeneratingImage, onAcceptAIUnsplashImage: onAcceptAIUnsplashImage, shouldShowAIUnsplashHeaderToolbar: shouldShowAIUnsplashHeaderToolbar, isFixedWidthImageOption: isFixedWidthImageOption, generateAIHeaderImage: generateAIHeaderImage } = t0;
    const [isModalOpenState, setIsModalOpenState] = (0, $42omo.useState)(false);
    const [isRepositionActive, setIsRepositionActive] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [initialUnsplashInfoArray, setInitialUnsplashInfoArray] = (0, $42omo.useState)(t1);
    let t2;
    if ($[1] !== coverPictureState) {
        t2 = ()=>{
            setIsModalOpenState(true);
            coverPictureState.setIsModalOpen(true);
        };
        $[1] = coverPictureState;
        $[2] = t2;
    } else t2 = $[2];
    const openModal = t2;
    let t3;
    if ($[3] !== coverPictureState) {
        t3 = ()=>{
            setIsModalOpenState(false);
            coverPictureState.setIsModalOpen(false);
        };
        $[3] = coverPictureState;
        $[4] = t3;
    } else t3 = $[4];
    const closeModal = t3;
    if (isUploadingPicture && coverPictureState.state.isUploadingPicture) {
        let t4;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                size: "medium"
            });
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== dynamicCoverImageHeight || $[7] !== hasCoverPicture) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($689140bd887be349$var$UploadingPictureWrapper, {
                "data-testid": "uploading-picture-wrapper",
                hasCoverPicture: hasCoverPicture,
                dynamicCoverImageHeight: dynamicCoverImageHeight
            }, t4);
            $[6] = dynamicCoverImageHeight;
            $[7] = hasCoverPicture;
            $[8] = t5;
        } else t5 = $[8];
        return t5;
    } else if ((shouldShowAIUnsplashHeaderToolbar || coverPictureState.state.shouldShowAIUnsplashHeaderToolbar && !shouldShowReposition) && hasCoverPicture) {
        let t4;
        if ($[9] !== isRegeneratingImage || $[10] !== onAcceptAIUnsplashImage || $[11] !== onRegenerate || $[12] !== onRemoveImage) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ba41bcbf59914f9a$export$f3c1fc220041ced8), {
                onAccept: onAcceptAIUnsplashImage,
                onRegenerate: onRegenerate,
                onRemoveImage: onRemoveImage,
                isRegeneratingImage: isRegeneratingImage
            });
            $[9] = isRegeneratingImage;
            $[10] = onAcceptAIUnsplashImage;
            $[11] = onRegenerate;
            $[12] = onRemoveImage;
            $[13] = t4;
        } else t4 = $[13];
        return t4;
    } else {
        if ((isRepositionActive || shouldShowReposition || !!coverPictureState.state.shouldShowReposition) && hasCoverPicture) {
            let t4;
            if ($[14] !== coverPictureState || $[15] !== dynamicCoverImageHeight || $[16] !== forceUpdate || $[17] !== initialPicturePosition || $[18] !== onSaveReposition || $[19] !== setShouldShowReposition || $[20] !== userOffline) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46b253a18b421305$export$78e1d98d4f84631f), {
                    initialPicturePosition: initialPicturePosition,
                    onSaveReposition: onSaveReposition,
                    setIsRepositionActive: setIsRepositionActive,
                    setShouldShowReposition: setShouldShowReposition,
                    coverPictureState: coverPictureState,
                    forceUpdate: forceUpdate,
                    userOffline: userOffline,
                    dynamicCoverImageHeight: dynamicCoverImageHeight
                });
                $[14] = coverPictureState;
                $[15] = dynamicCoverImageHeight;
                $[16] = forceUpdate;
                $[17] = initialPicturePosition;
                $[18] = onSaveReposition;
                $[19] = setShouldShowReposition;
                $[20] = userOffline;
                $[21] = t4;
            } else t4 = $[21];
            return t4;
        } else if (hasCoverPicture) {
            let t4;
            if ($[22] !== closeModal || $[23] !== contentId || $[24] !== coverPictureState || $[25] !== dynamicCoverImageHeight || $[26] !== generateAIHeaderImage || $[27] !== handleUnsplashUpload || $[28] !== initialUnsplashInfoArray || $[29] !== isFixedWidthImageOption || $[30] !== onImageWidthChange || $[31] !== onRemoveImage || $[32] !== openMediaBrowser || $[33] !== setIsUploadingPicture || $[34] !== spaceKey || $[35] !== userOffline) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d56946553982f95c$export$d83b52f1c3c4071e), {
                    userOffline: userOffline,
                    closeModal: closeModal,
                    openMediaBrowser: openMediaBrowser,
                    setIsRepositionActive: setIsRepositionActive,
                    onRemoveImage: onRemoveImage,
                    handleUnsplashUpload: handleUnsplashUpload,
                    setIsUploadingPicture: setIsUploadingPicture,
                    initialUnsplashInfoArray: initialUnsplashInfoArray,
                    setInitialUnsplashInfoArray: setInitialUnsplashInfoArray,
                    coverPictureState: coverPictureState,
                    contentId: contentId,
                    onImageWidthChange: onImageWidthChange,
                    spaceKey: spaceKey,
                    dynamicCoverImageHeight: dynamicCoverImageHeight,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    generateAIHeaderImage: generateAIHeaderImage
                });
                $[22] = closeModal;
                $[23] = contentId;
                $[24] = coverPictureState;
                $[25] = dynamicCoverImageHeight;
                $[26] = generateAIHeaderImage;
                $[27] = handleUnsplashUpload;
                $[28] = initialUnsplashInfoArray;
                $[29] = isFixedWidthImageOption;
                $[30] = onImageWidthChange;
                $[31] = onRemoveImage;
                $[32] = openMediaBrowser;
                $[33] = setIsUploadingPicture;
                $[34] = spaceKey;
                $[35] = userOffline;
                $[36] = t4;
            } else t4 = $[36];
            return t4;
        } else {
            let t4;
            if ($[37] !== closeModal || $[38] !== contentId || $[39] !== coverPictureState || $[40] !== floatingToolbarButtonStyle || $[41] !== generateAIHeaderImage || $[42] !== handleUnsplashUpload || $[43] !== initialUnsplashInfoArray || $[44] !== isModalOpenState || $[45] !== openMediaBrowser || $[46] !== openModal || $[47] !== setIsUploadingPicture || $[48] !== userOffline) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b276f472a35f7217$export$97958e565d90ce0a), {
                    userOffline: userOffline,
                    openModal: openModal,
                    closeModal: closeModal,
                    openMediaBrowser: openMediaBrowser,
                    isModalOpenState: isModalOpenState,
                    handleUnsplashUpload: handleUnsplashUpload,
                    setIsUploadingPicture: setIsUploadingPicture,
                    initialUnsplashInfoArray: initialUnsplashInfoArray,
                    setInitialUnsplashInfoArray: setInitialUnsplashInfoArray,
                    coverPictureState: coverPictureState,
                    floatingToolbarButtonStyle: floatingToolbarButtonStyle,
                    contentId: contentId,
                    generateAIHeaderImage: generateAIHeaderImage
                });
                $[37] = closeModal;
                $[38] = contentId;
                $[39] = coverPictureState;
                $[40] = floatingToolbarButtonStyle;
                $[41] = generateAIHeaderImage;
                $[42] = handleUnsplashUpload;
                $[43] = initialUnsplashInfoArray;
                $[44] = isModalOpenState;
                $[45] = openMediaBrowser;
                $[46] = openModal;
                $[47] = setIsUploadingPicture;
                $[48] = userOffline;
                $[49] = t4;
            } else t4 = $[49];
            return t4;
        }
    }
} : ({ hasCoverPicture: hasCoverPicture, openMediaBrowser: openMediaBrowser, onRemoveImage: onRemoveImage, userOffline: userOffline, setIsUploadingPicture: setIsUploadingPicture, isUploadingPicture: isUploadingPicture, handleUnsplashUpload: handleUnsplashUpload, initialPicturePosition: initialPicturePosition, onSaveReposition: onSaveReposition, shouldShowReposition: shouldShowReposition, setShouldShowReposition: setShouldShowReposition, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, forceUpdate: forceUpdate, contentId: contentId, dynamicCoverImageHeight: dynamicCoverImageHeight, onImageWidthChange: onImageWidthChange, spaceKey: spaceKey, onRegenerate: onRegenerate, isRegeneratingImage: isRegeneratingImage, onAcceptAIUnsplashImage: onAcceptAIUnsplashImage, shouldShowAIUnsplashHeaderToolbar: shouldShowAIUnsplashHeaderToolbar, isFixedWidthImageOption: isFixedWidthImageOption, generateAIHeaderImage: generateAIHeaderImage })=>{
    const [isModalOpenState, setIsModalOpenState] = (0, $42omo.useState)(false);
    const [isRepositionActive, setIsRepositionActive] = (0, $42omo.useState)(false);
    const [initialUnsplashInfoArray, setInitialUnsplashInfoArray] = (0, $42omo.useState)([]);
    const openModal = ()=>{
        setIsModalOpenState(true);
        coverPictureState.setIsModalOpen(true);
    };
    const closeModal = ()=>{
        setIsModalOpenState(false);
        coverPictureState.setIsModalOpen(false);
    };
    if (isUploadingPicture && coverPictureState.state.isUploadingPicture) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($689140bd887be349$var$UploadingPictureWrapper, {
        "data-testid": "uploading-picture-wrapper",
        hasCoverPicture: hasCoverPicture,
        dynamicCoverImageHeight: dynamicCoverImageHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium"
    }));
    else if ((shouldShowAIUnsplashHeaderToolbar || coverPictureState.state.shouldShowAIUnsplashHeaderToolbar && !shouldShowReposition) && hasCoverPicture) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ba41bcbf59914f9a$export$f3c1fc220041ced8), {
        onAccept: onAcceptAIUnsplashImage,
        onRegenerate: onRegenerate,
        onRemoveImage: onRemoveImage,
        isRegeneratingImage: isRegeneratingImage
    });
    else if ((isRepositionActive || shouldShowReposition || !!coverPictureState.state.shouldShowReposition) && hasCoverPicture) // shouldShowReposition = true when we just uploaded a photo
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46b253a18b421305$export$78e1d98d4f84631f), {
        initialPicturePosition: initialPicturePosition,
        onSaveReposition: onSaveReposition,
        setIsRepositionActive: setIsRepositionActive,
        setShouldShowReposition: setShouldShowReposition,
        coverPictureState: coverPictureState,
        forceUpdate: forceUpdate,
        userOffline: userOffline,
        dynamicCoverImageHeight: dynamicCoverImageHeight
    });
    else if (hasCoverPicture) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d56946553982f95c$export$d83b52f1c3c4071e), {
        userOffline: userOffline,
        closeModal: closeModal,
        openMediaBrowser: openMediaBrowser,
        setIsRepositionActive: setIsRepositionActive,
        onRemoveImage: onRemoveImage,
        handleUnsplashUpload: handleUnsplashUpload,
        setIsUploadingPicture: setIsUploadingPicture,
        initialUnsplashInfoArray: initialUnsplashInfoArray,
        setInitialUnsplashInfoArray: setInitialUnsplashInfoArray,
        coverPictureState: coverPictureState,
        contentId: contentId,
        onImageWidthChange: onImageWidthChange,
        spaceKey: spaceKey,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isFixedWidthImageOption: isFixedWidthImageOption,
        generateAIHeaderImage: generateAIHeaderImage
    });
    else // no cover picture
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b276f472a35f7217$export$97958e565d90ce0a), {
        userOffline: userOffline,
        openModal: openModal,
        closeModal: closeModal,
        openMediaBrowser: openMediaBrowser,
        isModalOpenState: isModalOpenState,
        handleUnsplashUpload: handleUnsplashUpload,
        setIsUploadingPicture: setIsUploadingPicture,
        initialUnsplashInfoArray: initialUnsplashInfoArray,
        setInitialUnsplashInfoArray: setInitialUnsplashInfoArray,
        coverPictureState: coverPictureState,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        contentId: contentId,
        generateAIHeaderImage: generateAIHeaderImage
    });
});

























const $0b61b96b5f67c6f4$var$UnsplashLoadingDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { dynamicCoverImageHeight: dynamicCoverImageHeight, hasUnsplashImageLoaded: hasUnsplashImageLoaded, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1isxe5u": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q7ysee _2rkon7od _kqswh2mm _4t3i1v90 _1bsb1osq",
                __cmplp.hasUnsplashImageLoaded ? "_tzy4idpf" : "_tzy4kb7n",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { dynamicCoverImageHeight: dynamicCoverImageHeight, hasUnsplashImageLoaded: hasUnsplashImageLoaded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1isxe5u": (0, $7sObp.default)(`${__cmplp.dynamicCoverImageHeight}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7ysee _2rkon7od _kqswh2mm _4t3i1v90 _1bsb1osq",
            __cmplp.hasUnsplashImageLoaded ? "_tzy4idpf" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $0b61b96b5f67c6f4$var$UnsplashWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        let t3;
        bb0: {
            if ((0, $6mKj3.expValEquals)("confluence_ttvc_fix_dynamic_cover_image_unsplash", "isEnabled", true)) {
                if (__cmplp.isFixedWidthImageOption) {
                    t3 = `${0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT}px`;
                    break bb0;
                }
                t3 = `${0, $75Ax4.CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE}px`;
                break bb0;
            }
            t3 = `${__cmplp.dynamicCoverImageHeight}px`;
        }
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_12kajtv": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_2rkon7od _1e0c1txw _1bsb1osq _kqswstnw _1tke1xef",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_12kajtv": (0, $7sObp.default)((()=>{
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                if ((0, $6mKj3.expValEquals)('confluence_ttvc_fix_dynamic_cover_image_unsplash', 'isEnabled', true)) {
                    if (__cmplp.isFixedWidthImageOption) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    return `${0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT}px`;
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    return `${0, $75Ax4.CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE}px`;
                }
                return `${__cmplp.dynamicCoverImageHeight}px`;
            })())
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkon7od _1e0c1txw _1bsb1osq _kqswstnw _1tke1xef",
            __cmplp.className
        ])
    });
});
const $0b61b96b5f67c6f4$export$a3a106beae779eb6 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { coverPicture: coverPicture, dynamicCoverImageHeight: dynamicCoverImageHeight, isFixedWidthImageOption: isFixedWidthImageOption, coverPictureDataPosition: coverPictureDataPosition, coverPictureDataId: coverPictureDataId } = t0;
    const [hasUnsplashImageLoaded, setHasUnsplashImageLoaded] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== dynamicCoverImageHeight || $[1] !== hasUnsplashImageLoaded) {
        t1 = !(0, $6mKj3.expValEquals)("confluence_ttvc_fix_dynamic_cover_image_unsplash", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0b61b96b5f67c6f4$var$UnsplashLoadingDiv, {
            hasUnsplashImageLoaded: hasUnsplashImageLoaded,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            "data-testid": "unsplash-loading-div"
        });
        $[0] = dynamicCoverImageHeight;
        $[1] = hasUnsplashImageLoaded;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = coverPicture.current.draft?.value.id ?? coverPictureDataId;
    const t3 = coverPicture.current.draft?.value.position ?? coverPictureDataPosition;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setHasUnsplashImageLoaded(true);
        };
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== isFixedWidthImageOption || $[5] !== t2 || $[6] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4hoOb.ImageWrapper), {
            "data-testid": "unsplash-cover-picture",
            id: "actual-cover-picture",
            "data-vc": "unsplash-cover-picture-editor",
            alt: "",
            src: t2,
            coverPicturePosition: t3,
            onLoad: t4,
            isFixedWidthImageOption: isFixedWidthImageOption,
            className: "cover-picture-wrapper-dangerously-set-inner-html"
        });
        $[4] = isFixedWidthImageOption;
        $[5] = t2;
        $[6] = t3;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== dynamicCoverImageHeight || $[9] !== hasUnsplashImageLoaded || $[10] !== isFixedWidthImageOption || $[11] !== t1 || $[12] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0b61b96b5f67c6f4$var$UnsplashWrapper, {
            hasUnsplashImageLoaded: hasUnsplashImageLoaded,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            isFixedWidthImageOption: isFixedWidthImageOption,
            "data-testid": "unsplash-wrapper"
        }, t1, t5);
        $[8] = dynamicCoverImageHeight;
        $[9] = hasUnsplashImageLoaded;
        $[10] = isFixedWidthImageOption;
        $[11] = t1;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ coverPicture: coverPicture, dynamicCoverImageHeight: dynamicCoverImageHeight, isFixedWidthImageOption: isFixedWidthImageOption, coverPictureDataPosition: coverPictureDataPosition, coverPictureDataId: coverPictureDataId })=>{
    const [hasUnsplashImageLoaded, setHasUnsplashImageLoaded] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0b61b96b5f67c6f4$var$UnsplashWrapper, {
        hasUnsplashImageLoaded: hasUnsplashImageLoaded,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isFixedWidthImageOption: isFixedWidthImageOption,
        "data-testid": "unsplash-wrapper"
    }, !(0, $6mKj3.expValEquals)('confluence_ttvc_fix_dynamic_cover_image_unsplash', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0b61b96b5f67c6f4$var$UnsplashLoadingDiv, {
        hasUnsplashImageLoaded: hasUnsplashImageLoaded,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        "data-testid": "unsplash-loading-div"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4hoOb.ImageWrapper), {
        "data-testid": "unsplash-cover-picture",
        id: "actual-cover-picture",
        "data-vc": "unsplash-cover-picture-editor" // need this empty alt tag for decorative images
        ,
        alt: "",
        src: coverPicture.current.draft?.value.id ?? coverPictureDataId,
        coverPicturePosition: coverPicture.current.draft?.value.position ?? coverPictureDataPosition,
        onLoad: ()=>{
            setHasUnsplashImageLoaded(true);
        },
        isFixedWidthImageOption: isFixedWidthImageOption,
        className: "cover-picture-wrapper-dangerously-set-inner-html"
    }));
};


const $e4cacfdae9b2fb53$var$i18n = (0, $cgtv4.defineMessages)({
    errorFlagTitle: {
        id: "page-cover-picture.error.flag.title",
        defaultMessage: "We can\u2019t upload your header image"
    },
    errorFlagDescription: {
        id: "page-cover-picture.error.flag.description",
        defaultMessage: "Refresh and try again."
    },
    suggestHeaderNextTime: {
        id: "page-cover-picture.ai-suggested-image-header.flag.suggest-next-time",
        defaultMessage: "Try a suggested header next time?"
    },
    suggestHeaderKeepSuggestions: {
        id: "page-cover-picture.ai-suggested-image-header.flag.suggest-next-time.accept" // eslint-disable-next-line @atlassian/i18n/require-description
        ,
        defaultMessage: "Yes, keep suggestions"
    },
    suggestHeaderTurnOffSuggestions: {
        id: "page-cover-picture.ai-suggested-image-header.flag.suggest-next-time.decline",
        defaultMessage: "No, turn off"
    }
});
const $e4cacfdae9b2fb53$var$COVER_IMAGE_FIXED_HEIGHT = 147; // if page has cover picture or is uploading picture, make space for the photo
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4cacfdae9b2fb53$var$CoverPictureWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, isReadOnly: isReadOnly, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_pjvxvw": (0, $7sObp.default)(__cmplp.dynamicCoverImageHeight, "px"),
                "--_1vcp0mh": (0, $7sObp.default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_2rkon7od _kqswh2mm _otyru2gc",
                (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && !__cmplp.isFixedWidthImageOption ? "_4t3i6w0c" : __cmplp.hasCoverPicture || __cmplp.isUploadingPicture ? "_4t3ifmv9" : "_4t3iidpf",
                (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.isFixedWidthImageOption ? "_1bsb1c3h" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && !__cmplp.isFixedWidthImageOption ? "_1bsb1osq" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.width ? "_1bsb1efm" : "_1bsb1osq",
                !__cmplp.isReadOnly ? "_80omtlke" : "_80om1wug",
                __cmplp.hasCoverPicture || __cmplp.isUploadingPicture ? "_19pk12x7" : "_19pkze3t",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, isReadOnly: isReadOnly, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_pjvxvw": (0, $7sObp.default)(__cmplp.dynamicCoverImageHeight, "px"),
            "--_1vcp0mh": (0, $7sObp.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkon7od _kqswh2mm _otyru2gc",
            (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && !__cmplp.isFixedWidthImageOption ? "_4t3i6w0c" : __cmplp.hasCoverPicture || __cmplp.isUploadingPicture ? "_4t3ifmv9" : "_4t3iidpf",
            (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.isFixedWidthImageOption ? "_1bsb1c3h" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && !__cmplp.isFixedWidthImageOption ? "_1bsb1osq" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.width ? "_1bsb1efm" : "_1bsb1osq",
            !__cmplp.isReadOnly ? "_80omtlke" : "_80om1wug",
            __cmplp.hasCoverPicture || __cmplp.isUploadingPicture ? "_19pk12x7" : "_19pkze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e4cacfdae9b2fb53$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "img" : t2;
        const { isFixedWidthImageOption: isFixedWidthImageOption, coverPicturePosition: coverPicturePosition, ...__cmpldp } = __cmplp;
        const t3 = `center ${__cmplp.coverPicturePosition}%`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_7bw3ey": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_2rkon7od _1bsb1osq _5ral1dfr _kqswstnw _rsuf19is _1h1t1u5u _16l4kb7n",
                __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i6w0c",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedWidthImageOption: isFixedWidthImageOption, coverPicturePosition: coverPicturePosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_7bw3ey": (0, $7sObp.default)(`center ${__cmplp.coverPicturePosition}%`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkon7od _1bsb1osq _5ral1dfr _kqswstnw _rsuf19is _1h1t1u5u _16l4kb7n",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i6w0c",
            __cmplp.className
        ])
    });
}); // TypeScript gets a bit cranky when we have two components with conflicting signatures in a ternary, so instead we just wrap it here to keep the signatures consistent/empty.
const $e4cacfdae9b2fb53$var$WrappedTwoStageHydration = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
            name: "editor-page-cover-picture"
        }, props.children);
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "editor-page-cover-picture"
    }, props.children);
const $e4cacfdae9b2fb53$var$EditorPageCoverPictureComponent = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, isPublishingContent: isPublishingContent, contentType: contentType, userOffline: userOffline, hasCoverPicture: hasCoverPicture, coverPictureState: coverPictureState, isUnpublishedDraft: isUnpublishedDraft, flags: flags, floatingToolbarButtonStyle: floatingToolbarButtonStyle, width: width, dynamicCoverImageHeight: dynamicCoverImageHeight, isReadOnly: isReadOnly, spaceKey: spaceKey, aiSuggestedUnsplashImages: aiSuggestedUnsplashImages, isFixedWidthImageOption: isFixedWidthImageOption, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus })=>{
    const [isMediaBrowserOpen, setIsMediaBrowserOpen] = (0, $42omo.useState)(false);
    const { isExternalShareRequest: isExternalShare } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const [isUploadingPicture, setIsUploadingPicture] = (0, $42omo.useState)(false);
    const [isRegeneratingImage, setIsRegeneratingImage] = (0, $42omo.useState)(false);
    const [regenerationCount, setRegenerationCount] = (0, $42omo.useState)(0); // mediaConfig does not use onUploadRejection when in read only (RendererMediaProvider), but does need it otherwise (EditorMediaProvider).
    const [mediaConfig, setMediaConfig] = (0, $42omo.useState)(null); // Using ref since onHandleUploadEnd event uses previous cover picture information and upload will fail
    // since the information is from the past render
    const coverPicture = (0, $42omo.useRef)({
        draft: null
    }); // need this force update since we are using useRef for the cover picture and therefore won't update the image automatically on change
    const [, forceUpdate] = (0, $42omo.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)(); // need this state since we want to show reposition option right after we upload a photo
    const [shouldShowReposition, setShouldShowReposition] = (0, $42omo.useState)(false);
    const [shouldShowAIUnsplashHeaderToolbar, setShouldShowAIUnsplashHeaderToolbar] = (0, $42omo.useState)(false);
    const ssrConfig = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        isExternalShare: isExternalShare
    });
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const hasSSRConfigInSSRModeOrHydration = (isServerPlaceholder || window.__SSR_RENDERED__) && ssrConfig;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const intl = (0, $8C5kA.default)();
    const [currentAIUnsplashImageIndex, setCurrentAIUnsplashImageIndex] = (0, $42omo.useState)(0);
    const { updateContentProperty: updateContentProperty } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page',
        options: {
            refetchQueries: ()=>[
                    {
                        query: (0, $gr7Mm.CoverPictureQuery),
                        variables: {
                            contentId: contentId,
                            status: [
                                'draft'
                            ],
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        }
                    }
                ]
        }
    });
    const { data: data, refetch: refetch } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $gr7Mm.CoverPictureQuery), {
        context: {
            single: true
        },
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        }
    });
    const coverPictureData = (0, $3WPGR.getRendererCoverPictureInfo)(data, isLivePage);
    const coverPictureDataPosition = coverPictureData?.coverPicture?.published?.value?.position;
    const coverPictureDataId = coverPictureData?.coverPicture?.published?.value?.id; // Need this since the isUnsplash prop isn't getting the up to date values
    // Check if the cover picture is from Unsplash or Atlassian hosted CDN (dam-cdn or wac-cdn)
    const coverPictureId = coverPicture.current?.draft?.value?.id;
    const isUnsplashLocalCheck = (0, $9wGTI.fg)('cc_create_page_header_image_api_update') ? (0, $3WPGR.isAllowedExternalCoverPictureUrl)(coverPictureId) : coverPictureId?.includes('images.unsplash.com');
    const isGeneratingHeaderImage = aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW';
    const [mutateCoverPictureIdExperimental] = (0, $1KmJq.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $6b87c6340da04bd8$export$34c97a669cfd186c), {
        refetchQueries: ()=>[
                {
                    query: (0, $gr7Mm.CoverPictureQuery),
                    variables: {
                        contentId: contentId,
                        status: [
                            'draft'
                        ],
                        draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                    }
                }
            ]
    });
    const [mutateCoverPictureWidth] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation EditorPageCoverPictureUpdateCoverPictureWidthMutation($contentId:ID!$coverPictureWidth:GraphQLCoverPictureWidth!){updateCoverPictureWidth(input:{contentId:$contentId coverPictureWidth:$coverPictureWidth}){content{id}}}`, {
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMPANY_HUB
            });
        },
        ignoreResults: true // don't want to update cache with content info
    });
    const onCoverPictureUpdatedSubscriptionData = (0, $42omo.useCallback)(async (_, response)=>{
        try {
            await refetch();
            const { coverPictureUpdated: coverPictureUpdated } = response || {};
            const value = JSON.parse(coverPictureUpdated?.value);
            const version = coverPictureUpdated?.version;
            coverPicture.current['draft'] = {
                value: value,
                version: version
            };
            coverPictureState.setHasCoverPicture(true);
            setIsUploadingPicture(false);
            coverPictureState.setIsUploadingPicture(false);
            coverPictureState.setCoverPictureId(value.id);
            setIsRegeneratingImage(false);
            forceUpdate(Math.random());
        } catch (error_0) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_0, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_0);
        }
    }, [
        refetch,
        coverPictureState
    ]);
    const onCoverPictureWidthUpdatedSubscription = (0, $42omo.useCallback)((__0, response_0)=>{
        const { coverPictureWidthUpdated: coverPictureWidthUpdated } = response_0 || {};
        const value_0 = coverPictureWidthUpdated?.coverPictureWidth;
        coverPictureState.toggleCoverPictureWidthButton(value_0);
        forceUpdate(Math.random());
    }, [
        coverPictureState
    ]);
    const onCoverPictureDeletedSubscription = (0, $42omo.useCallback)(async ()=>{
        try {
            await refetch();
            coverPicture.current['draft'] = null;
            coverPictureState.setHasCoverPicture(false);
            coverPictureState.setCoverPictureId(null);
            forceUpdate(Math.random());
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        refetch,
        coverPictureState
    ]);
    const subscriptionResourceType = contentType || 'page';
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditingCoverPictureSubscription',
        contentId: contentId,
        delta: 'coverPictureUpdated',
        contentType: subscriptionResourceType,
        onDataReceived: onCoverPictureUpdatedSubscriptionData
    });
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditorCoverPictureDeletedSubscription',
        contentId: contentId,
        delta: 'coverPictureDeleted',
        contentType: subscriptionResourceType,
        onDataReceived: onCoverPictureDeletedSubscription
    });
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditorCoverPictureWidthUpdatedSubscription',
        contentId: contentId,
        delta: 'coverPictureWidthUpdated',
        contentType: subscriptionResourceType,
        onDataReceived: onCoverPictureWidthUpdatedSubscription
    }); // Check for existing cover picture
    (0, $42omo.useEffect)(()=>{
        const properties = data?.content?.nodes?.[0]?.properties?.nodes || [];
        const draft = properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT);
        coverPicture.current = {
            draft: (0, $3WPGR.propertyToId)(draft)
        };
        forceUpdate(Math.random());
    }, [
        data
    ]); // Setup media config
    (0, $42omo.useEffect)(()=>{
        const showAttachmentLimitReachedFlag = (rejectionData)=>{
            if (flags && rejectionData) flags.showErrorFlag((0, $2vVvv.getAttachmentSizeLimitErrorFlag)(rejectionData, intl)).then(()=>{
                setIsUploadingPicture(false);
                coverPictureState.setIsUploadingPicture(false);
                experienceTracker.abort({
                    name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE),
                    reason: 'Cover picture media upload too large'
                });
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'pageCoverPictureAttachmentTooLargeFlag'
                    }
                }).fire();
            });
            return !!rejectionData;
        }; // If read only, use renderer media provider, as we only need the auth provider from rendererMediaProvider, and user without edit perms (read only) doesn't have access to editorMediaProvider APIs
        // If not read only, use editor media provider
        const createMediaConfig = async ()=>{
            if (isReadOnly) {
                const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                    contentId: contentId,
                    isExternalShare: false
                });
                if (!viewMediaClientConfig) return null;
                setMediaConfig({
                    collection: `contentId-${contentId}`,
                    authProvider: viewMediaClientConfig.authProvider
                });
            } else {
                const { uploadParams: uploadParams, uploadMediaClientConfig: uploadMediaClientConfig } = await (0, $4IoVL.createEditorMediaProvider)({
                    contentId: contentId,
                    contentType: 'page',
                    isExternalShare: isExternalShare,
                    onUploadRejection: flags ? showAttachmentLimitReachedFlag : undefined
                });
                if (uploadMediaClientConfig == undefined) return null;
                setMediaConfig({
                    collection: uploadParams?.collection,
                    authProvider: uploadMediaClientConfig.authProvider,
                    onUploadRejection: uploadParams?.onUploadRejection,
                    useSha256ForUploads: uploadMediaClientConfig?.useSha256ForUploads
                });
            }
        };
        createMediaConfig();
    }, [
        contentId,
        isExternalShare,
        flags,
        intl,
        coverPictureState,
        createAnalyticsEvent,
        experienceTracker,
        isReadOnly
    ]); // handling user publishes - we only need to worry about firing the analytic event as backend will take care of the
    // published cover picture content property mutation due to scheduled publishes
    (0, $42omo.useEffect)(()=>{
        // fire analytic if we're publishing a page with a cover image
        if (isPublishingContent && !!coverPicture.current?.draft?.value.id) {
            if (isUnpublishedDraft) {
                if (coverPictureState.state.isAIUnsplashImage) createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'published',
                        actionSubject: 'aiUnsplashImage',
                        actionSubjectId: 'aiSuggestedUnsplashImage',
                        source: 'editorPageCoverPicture',
                        objectId: contentId
                    }
                }).fire();
                else createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'createdWithHeaderImage',
                        actionSubject: 'page',
                        objectId: contentId,
                        source: 'editorPageCoverPicture'
                    }
                }).fire();
            } else createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'updatedWithHeaderImage',
                    actionSubject: 'page',
                    objectId: contentId,
                    source: 'editorPageCoverPicture'
                }
            }).fire();
        }
    }, [
        contentId,
        isPublishingContent,
        isUnpublishedDraft,
        createAnalyticsEvent,
        coverPictureState.state.isAIUnsplashImage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isPublishingContent && hasCoverPicture) coverPictureState.setShouldShowReposition(false);
    }, [
        hasCoverPicture,
        isPublishingContent,
        coverPictureState
    ]);
    const showErrorFlag = ()=>{
        flags.showFlag({
            type: 'error',
            title: formatMessage($e4cacfdae9b2fb53$var$i18n.errorFlagTitle),
            description: formatMessage($e4cacfdae9b2fb53$var$i18n.errorFlagDescription),
            messageType: 'transactional',
            messageId: 'page-cover-picture-error-flag'
        });
        setIsUploadingPicture(false);
        coverPictureState.setIsUploadingPicture(false);
        experienceTracker.stopOnError({
            name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE),
            error: new Error('Error with cover picture media upload')
        });
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'pageCoverPictureErrorFlag'
            }
        }).fire();
    };
    const handleUploadStart = ()=>{
        setIsUploadingPicture(true);
        coverPictureState.setIsUploadingPicture(true);
        coverPictureState.setIsChangingPicture(false);
        experienceTracker.start({
            name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE)
        });
    };
    const handleUploadEnd = (event)=>{
        const fileType = event.file.type;
        const id = event?.file?.id;
        if (!fileType.includes('image')) showErrorFlag();
        else if (id) {
            // must JSON stringify propertyValue object since mutation expects a string for this parameter
            const propertyValue = JSON.stringify({
                id: id,
                position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
            });
            const version_0 = String((coverPicture.current?.draft?.version || 0) + 1);
            if ((0, $6mKj3.isExperimentEnabled)('migrate_off_experimentalupdatecontentproperty')) updateContentProperty({
                propertyKey: (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT,
                propertyValue: propertyValue,
                isDelete: false,
                hasExistingProperty: hasCoverPicture
            });
            else mutateCoverPictureIdExperimental({
                variables: {
                    contentId: contentId,
                    propertyValue: propertyValue,
                    propertyKey: (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT,
                    versionNumber: version_0
                }
            });
            setShouldShowReposition(true);
            coverPictureState.setShouldShowReposition(true);
            experienceTracker.succeed({
                name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE)
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'added',
                    actionSubject: 'image',
                    actionSubjectId: 'headerImageAdded',
                    source: 'editorPageCoverPicture',
                    attributes: {
                        imageSource: 'uploaded',
                        imageId: id,
                        inputMethod: 'header',
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        } else showErrorFlag();
    };
    const handleUnsplashUpload = (0, $42omo.useCallback)((photoURL, triggeredFromRegenerate = false)=>{
        if (!triggeredFromRegenerate) {
            setIsUploadingPicture(true);
            coverPictureState.setIsUploadingPicture(true);
        }
        const propertyValue_0 = JSON.stringify({
            id: photoURL,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        });
        const version_1 = String((coverPicture.current?.draft?.version || 0) + 1);
        if ((0, $6mKj3.isExperimentEnabled)('migrate_off_experimentalupdatecontentproperty')) updateContentProperty({
            propertyKey: (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT,
            propertyValue: propertyValue_0,
            isDelete: false,
            hasExistingProperty: hasCoverPicture
        });
        else mutateCoverPictureIdExperimental({
            variables: {
                contentId: contentId,
                propertyValue: propertyValue_0,
                propertyKey: (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT,
                versionNumber: version_1
            }
        });
        if (coverPictureState.state.isAIUnsplashImage) {
            setShouldShowReposition(false);
            setShouldShowAIUnsplashHeaderToolbar(true);
            coverPictureState.setShouldShowAIUnsplashHeaderToolbar(true);
        } else {
            setShouldShowReposition(true);
            coverPictureState.setShouldShowReposition(true);
        }
        experienceTracker.succeed({
            name: (0, $irVI7.COVER_PICTURE_UNSPLASH_UPLOAD_EXPERIENCE)
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'added',
                actionSubject: 'image',
                actionSubjectId: 'headerImageAdded',
                source: 'editorPageCoverPicture',
                attributes: {
                    imageSource: 'unsplash',
                    imageId: photoURL,
                    inputMethod: 'header',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        coverPictureState,
        createAnalyticsEvent,
        experienceTracker,
        isLivePage,
        mutateCoverPictureIdExperimental,
        updateContentProperty,
        hasCoverPicture
    ]);
    const handleAIGeneratedUpload = (0, $42omo.useCallback)((mediaFileId)=>{
        const propertyValue_1 = JSON.stringify({
            id: mediaFileId,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        });
        const version_2 = String((coverPicture.current?.draft?.version || 0) + 1);
        if ((0, $6mKj3.isExperimentEnabled)('migrate_off_experimentalupdatecontentproperty')) updateContentProperty({
            propertyKey: (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT,
            propertyValue: propertyValue_1,
            isDelete: false,
            hasExistingProperty: hasCoverPicture
        });
        else mutateCoverPictureIdExperimental({
            variables: {
                contentId: contentId,
                propertyValue: propertyValue_1,
                propertyKey: (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT,
                versionNumber: version_2
            }
        });
        setAIHeaderImageStatus?.('SUCCESSFULLY_SET');
    }, [
        contentId,
        coverPicture,
        mutateCoverPictureIdExperimental,
        setAIHeaderImageStatus,
        updateContentProperty,
        hasCoverPicture
    ]);
    const updateCoverPictureState = (0, $42omo.useCallback)(async ()=>{
        await coverPictureState.setHasCoverPicture(true);
    }, [
        coverPictureState
    ]);
    (0, $42omo.useEffect)(()=>{
        if (aiSuggestedUnsplashImages?.[0] && !isUploadingPicture && !coverPictureState.state.hasCoverPicture) try {
            handleUnsplashUpload(aiSuggestedUnsplashImages?.[currentAIUnsplashImageIndex]?.fullSizeImageUrl);
        } finally{
            updateCoverPictureState();
        }
    }, [
        currentAIUnsplashImageIndex,
        aiSuggestedUnsplashImages,
        isUploadingPicture,
        handleUnsplashUpload,
        coverPictureState.state.hasCoverPicture,
        coverPictureState.setHasCoverPicture,
        updateCoverPictureState
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.isExperimentEnabled)('confluence_aifc_header_image_generation_experiment')) return;
        if (isGeneratingHeaderImage) coverPictureState.setIsUploadingPicture(true);
        else {
            coverPictureState.setIsUploadingPicture(false);
            if (aiHeaderImageFileId && aiHeaderImageStatus !== 'SUCCESSFULLY_SET') try {
                handleAIGeneratedUpload(aiHeaderImageFileId);
            } finally{
                updateCoverPictureState();
            }
        }
    }, [
        isGeneratingHeaderImage,
        coverPictureState,
        aiHeaderImageFileId,
        handleAIGeneratedUpload,
        updateCoverPictureState,
        aiHeaderImageStatus
    ]);
    const onAcceptAIUnsplashImage = (0, $42omo.useCallback)(async ()=>{
        setShouldShowReposition(true);
        setShouldShowAIUnsplashHeaderToolbar(false);
        coverPictureState.setShouldShowAIUnsplashHeaderToolbar(false);
        coverPictureState.setShouldShowReposition(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'accepted',
                actionSubject: 'aiUnsplashImage',
                actionSubjectId: 'aiSuggestedUnsplashImage',
                source: 'editorPageCoverPicture',
                attributes: {
                    regenerationCount: regenerationCount
                }
            }
        }).fire();
    }, [
        coverPictureState,
        regenerationCount,
        createAnalyticsEvent
    ]);
    const onRegenerate = (0, $42omo.useCallback)(async ()=>{
        if (aiSuggestedUnsplashImages && aiSuggestedUnsplashImages.length > 0) {
            // This is used for to tell the toolbar that the image is regenerating
            setIsRegeneratingImage(true); // This is used for analytics to track if the user has regenerated and if they ultimately accepted or declined
            setRegenerationCount(regenerationCount + 1); // This will loop through the images in the array and circle back to the first image if the last image is reached
            // The images get less and less relevant as the index increases so it's better to start from the beginning
            // Than it is to get the next 30 results from the API
            const nextIndex = (currentAIUnsplashImageIndex + 1) % aiSuggestedUnsplashImages.length;
            setCurrentAIUnsplashImageIndex(nextIndex);
            handleUnsplashUpload(aiSuggestedUnsplashImages?.[nextIndex]?.fullSizeImageUrl, true);
        }
    }, [
        currentAIUnsplashImageIndex,
        aiSuggestedUnsplashImages,
        handleUnsplashUpload,
        setIsRegeneratingImage,
        setRegenerationCount,
        regenerationCount
    ]);
    const sendAIUnsplashOptInAnalytics = (0, $42omo.useCallback)((optIn)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'optIn',
                actionSubject: 'aiUnsplashImage',
                actionSubjectId: 'aiSuggestedUnsplashImage',
                source: 'editorPageCoverPicture',
                attributes: {
                    optIn: optIn
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const showAIUnsplashHeaderRemovedFlag = (0, $42omo.useCallback)(()=>{
        if ((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).AI_UNSPLASH_HEADER_ACCEPTED) !== null) return;
        flags.showFlag({
            title: formatMessage($e4cacfdae9b2fb53$var$i18n.suggestHeaderNextTime),
            type: 'info',
            id: 'ai-suggested-image-header-removed',
            actions: [
                {
                    content: formatMessage($e4cacfdae9b2fb53$var$i18n.suggestHeaderKeepSuggestions),
                    onClick: ()=>{
                        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AI_UNSPLASH_HEADER_ACCEPTED, 'true');
                        sendAIUnsplashOptInAnalytics(true);
                        flags.hideFlag('ai-suggested-image-header-removed');
                    }
                },
                {
                    content: formatMessage($e4cacfdae9b2fb53$var$i18n.suggestHeaderTurnOffSuggestions),
                    onClick: ()=>{
                        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AI_UNSPLASH_HEADER_ACCEPTED, 'false');
                        sendAIUnsplashOptInAnalytics(false);
                        flags.hideFlag('ai-suggested-image-header-removed');
                    }
                }
            ]
        });
        setTimeout(()=>{
            flags.hideFlag('ai-suggested-image-header-removed');
        }, 8000);
    }, [
        flags,
        formatMessage,
        sendAIUnsplashOptInAnalytics
    ]);
    const onRemoveImage = (0, $42omo.useCallback)(async ()=>{
        coverPictureState.setIsRemovingPicture(true);
        if ((0, $6mKj3.isExperimentEnabled)('migrate_off_experimentalupdatecontentproperty')) updateContentProperty({
            propertyKey: (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT,
            isDelete: true,
            hasExistingProperty: hasCoverPicture
        });
        else mutateCoverPictureIdExperimental({
            variables: {
                contentId: contentId,
                propertyKey: (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT,
                isDelete: true
            }
        });
        coverPictureState.setIsChangingPicture(false);
        if (coverPictureState.state.isAIUnsplashImage) {
            coverPictureState.setIsAIUnsplashImage(false);
            coverPictureState.setAISuggestedUnsplashImages(undefined);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'removed',
                    actionSubject: 'aiUnsplashImage',
                    actionSubjectId: 'aiSuggestedUnsplashImage',
                    source: 'editorPageCoverPicture',
                    attributes: {
                        regenerationCount: regenerationCount
                    }
                }
            }).fire();
            showAIUnsplashHeaderRemovedFlag();
        }
        coverPictureState.setIsRemovingPicture(false);
        experienceTracker.succeed({
            name: (0, $irVI7.COVER_PICTURE_REMOVE_EXPERIENCE)
        });
    }, [
        contentId,
        mutateCoverPictureIdExperimental,
        coverPictureState,
        experienceTracker,
        showAIUnsplashHeaderRemovedFlag,
        createAnalyticsEvent,
        regenerationCount,
        updateContentProperty,
        hasCoverPicture
    ]);
    const onImageWidthChange = (0, $42omo.useCallback)(async (coverPictureWidth)=>{
        if (coverPictureWidth !== coverPictureState.state.coverPictureWidth) {
            coverPictureState.toggleCoverPictureWidthButton(coverPictureWidth); //hack the input and outout have different capitalizations TT_TT
            // the mutation returns lowercase, the mutation expects uppercase
            await mutateCoverPictureWidth({
                variables: {
                    contentId: contentId,
                    // Casting to GraphQLCoverPictureWidth as structurally equivalent enums are not equal in TS
                    coverPictureWidth: coverPictureWidth.toUpperCase()
                }
            });
        }
    }, [
        contentId,
        mutateCoverPictureWidth,
        coverPictureState
    ]);
    const onSaveReposition = async (position)=>{
        // check that the position isn't the same as the current one
        if (position != coverPicture.current?.draft?.value.position) {
            const version_3 = String((coverPicture.current?.draft?.version || 0) + 1);
            const propertyValue_2 = JSON.stringify({
                id: coverPicture.current?.draft?.value.id,
                position: position
            });
            coverPicture.current.draft.value.position = position;
            coverPicture.current.draft.version = parseInt(version_3);
            if ((0, $6mKj3.isExperimentEnabled)('migrate_off_experimentalupdatecontentproperty')) updateContentProperty({
                propertyKey: (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT,
                propertyValue: propertyValue_2,
                isDelete: false,
                hasExistingProperty: hasCoverPicture
            });
            else mutateCoverPictureIdExperimental({
                variables: {
                    contentId: contentId,
                    propertyValue: propertyValue_2,
                    propertyKey: (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT,
                    versionNumber: version_3
                }
            });
        }
    };
    const openMediaBrowser = ()=>{
        setIsMediaBrowserOpen(true);
    };
    const closeMediaBrowser = ()=>{
        setIsMediaBrowserOpen(false);
    };
    const createLiveDocHeaderImageAnalyticsEvent = (0, $42omo.useCallback)((isUnsplashImage)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'LiveDocHeaderImage',
                actionSubjectId: 'liveDocHeaderImage',
                source: 'liveDocHeaderImage',
                attributes: {
                    headerImageType: isUnsplashImage ? 'unsplash' : 'user-uploaded'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (hasCoverPicture && isLivePage && isUnsplashLocalCheck != null) createLiveDocHeaderImageAnalyticsEvent(isUnsplashLocalCheck);
    }, [
        isUnsplashLocalCheck,
        isLivePage,
        hasCoverPicture,
        createLiveDocHeaderImageAnalyticsEvent
    ]);
    const ConditionalTwoStageHydration = (0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? $e4cacfdae9b2fb53$var$WrappedTwoStageHydration : (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConditionalTwoStageHydration, null, hasCoverPicture && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style" // eslint-disable-next-line react/no-danger
    , {
        dangerouslySetInnerHTML: {
            __html: `
									@container editor-area (width < 760px) {
										.cover-picture-wrapper-dangerously-set-inner-html {
											height: 147px
										}
									}
									@container editor-area (width >= 4071px) {
										.cover-picture-wrapper-dangerously-set-inner-html {
											height: 750px
										}
									}
									`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e4cacfdae9b2fb53$var$CoverPictureWrapper, {
        hasCoverPicture: hasCoverPicture,
        isUploadingPicture: isUploadingPicture,
        "data-testid": "cover-picture-wrapper",
        userOffline: userOffline,
        width: width,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        className: "cover-picture-wrapper-dangerously-set-inner-html",
        isFixedWidthImageOption: isFixedWidthImageOption,
        isReadOnly: isReadOnly
    }, hasCoverPicture && (mediaConfig || hasSSRConfigInSSRModeOrHydration) && (isUnsplashLocalCheck ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0b61b96b5f67c6f4$export$a3a106beae779eb6), {
        coverPicture: coverPicture,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isFixedWidthImageOption: isFixedWidthImageOption,
        coverPictureDataPosition: coverPictureDataPosition,
        coverPictureDataId: coverPictureDataId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6daaa50e0e3ea99a$export$22e679d20747684f), {
        coverPicture: coverPicture,
        mediaConfig: mediaConfig,
        ssrConfig: ssrConfig,
        contentId: contentId,
        showErrorFlag: showErrorFlag,
        hasSSRConfigInSSRModeOrHydration: hasSSRConfigInSSRModeOrHydration,
        isFixedWidthImageOption: isFixedWidthImageOption,
        isAIGenerated: !!aiHeaderImageFileId
    })), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $689140bd887be349$export$4103f8c62b69a0b3), {
        hasCoverPicture: hasCoverPicture,
        openMediaBrowser: openMediaBrowser,
        onRemoveImage: onRemoveImage,
        userOffline: userOffline,
        isUploadingPicture: isUploadingPicture,
        handleUnsplashUpload: handleUnsplashUpload,
        setIsUploadingPicture: setIsUploadingPicture,
        initialPicturePosition: coverPicture.current.draft?.value.position,
        onSaveReposition: onSaveReposition,
        shouldShowReposition: shouldShowReposition,
        setShouldShowReposition: setShouldShowReposition,
        coverPictureState: coverPictureState,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        forceUpdate: forceUpdate,
        contentId: contentId,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        onImageWidthChange: onImageWidthChange,
        spaceKey: spaceKey,
        isRegeneratingImage: isRegeneratingImage,
        onRegenerate: onRegenerate,
        onAcceptAIUnsplashImage: onAcceptAIUnsplashImage,
        shouldShowAIUnsplashHeaderToolbar: shouldShowAIUnsplashHeaderToolbar,
        isFixedWidthImageOption: isFixedWidthImageOption,
        generateAIHeaderImage: generateAIHeaderImage
    }))), !isReadOnly && mediaConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10CSJ.BrowserLoader), {
        mediaClientConfig: {
            authProvider: mediaConfig?.authProvider,
            useSha256ForUploads: mediaConfig?.useSha256ForUploads
        },
        config: {
            multiple: false,
            fileExtensions: [
                '.jpg',
                '.jpeg',
                '.png',
                '.gif'
            ],
            uploadParams: {
                collection: mediaConfig.collection,
                onUploadRejection: mediaConfig?.onUploadRejection
            }
        },
        isOpen: isMediaBrowserOpen,
        onClose: closeMediaBrowser,
        onUploadsStart: handleUploadStart,
        onError: showErrorFlag,
        onEnd: handleUploadEnd
    }));
});
const $e4cacfdae9b2fb53$export$61fcba19b6a07b00 = (0, $7aRa9.withFlags)((0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($e4cacfdae9b2fb53$var$EditorPageCoverPictureComponent));
module.exports["ImageWrapper"] = $e4cacfdae9b2fb53$export$75f07c36086c2c81;
module.exports["EditorPageCoverPicture"] = $e4cacfdae9b2fb53$export$61fcba19b6a07b00;

});

parcelRegister("10CSJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");





class $330e3eb3197f64f9$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser && (0, $dh538.fg)('jfp-magma-media-clipboard-init-after-mount')) Promise.all([
            (parcelRequire("iH8uq")),
            (parcelRequire("1l25w"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser && !(0, $dh538.fg)('jfp-magma-media-clipboard-init-after-mount')) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("iH8uq")),
                (parcelRequire("1l25w"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
        };
    }
}
$330e3eb3197f64f9$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $330e3eb3197f64f9$export$3ce634ac4a869e2c;

});

parcelRegister("iH8uq", function(module, exports) {

let $d9c2d40b8fc19a20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d9c2d40b8fc19a20$var$load("7Sft8"),
    $d9c2d40b8fc19a20$var$load("joFPh"),
    $d9c2d40b8fc19a20$var$load("ht6hk"),
    $d9c2d40b8fc19a20$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("1l25w", function(module, exports) {

let $0f995f4145d6cbfc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0f995f4145d6cbfc$var$load("7Sft8"),
    $0f995f4145d6cbfc$var$load("ht6hk"),
    $0f995f4145d6cbfc$var$load("f35QR"),
    $0f995f4145d6cbfc$var$load("eVYW1"),
    $0f995f4145d6cbfc$var$load("ls0Um"),
    $0f995f4145d6cbfc$var$load("020xd"),
    $0f995f4145d6cbfc$var$load("eTBsW"),
    $0f995f4145d6cbfc$var$load("bYxCZ"),
    $0f995f4145d6cbfc$var$load("6HBYC"),
    $0f995f4145d6cbfc$var$load("eDqo1"),
    $0f995f4145d6cbfc$var$load("lxiFd"),
    $0f995f4145d6cbfc$var$load("1oiJ6"),
    $0f995f4145d6cbfc$var$load("huUvS"),
    $0f995f4145d6cbfc$var$load("dT77m"),
    $0f995f4145d6cbfc$var$load("6vhrJ"),
    $0f995f4145d6cbfc$var$load("hqblC")
]).then(()=>parcelRequire('4rZL5'));

});

parcelRegister("2vVvv", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $57725dc45b51a081$var$attachmentSizeErrorFlagI18n = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-size-limit-error.title",
        defaultMessage: "{fileName} is too large to upload"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-size-limit-error.description",
        defaultMessage: "Attachments must be {size} or less."
    },
    learnMore: {
        id: "fabric-media-support.attachment-size-limit-error.learn-more",
        defaultMessage: "Learn more"
    }
});
const $57725dc45b51a081$var$sizeLimitLearnMoreLink = 'https://support.atlassian.com/confluence-cloud/docs/upload-a-file/';
const $57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-zero-byte-error.title",
        defaultMessage: "{fileName} is empty (zero bytes)"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-zero-byte.description",
        defaultMessage: "Attachments must be at least 1 byte of size"
    }
});
const $57725dc45b51a081$export$f2d538a5633fea72 = (bytes, maxMagnitude)=>{
    if (bytes <= 0) return '0 bytes';
    const k = 1024;
    const decimals = 2;
    const units = [
        'bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    let maxIndex = units.length - 1;
    let exponent = Math.floor(Math.log(bytes) / Math.log(k));
    if (maxMagnitude && maxMagnitude < maxIndex) maxIndex = maxMagnitude;
    exponent = exponent > maxIndex ? maxIndex : exponent;
    return `${parseFloat((bytes / Math.pow(k, exponent)).toFixed(decimals))} ${units[exponent]}`;
};
const $57725dc45b51a081$export$1c61cf0ed486df46 = (data, intl)=>{
    if (data.reason === 'fileSizeLimitExceeded') return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorDescription, {
            size: $57725dc45b51a081$export$f2d538a5633fea72(data.limit)
        }),
        actions: [
            {
                content: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.learnMore),
                onClick: ()=>{
                    window.open($57725dc45b51a081$var$sizeLimitLearnMoreLink, '_blank');
                }
            }
        ]
    };
    else return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorDescription)
    };
};
module.exports["getAttachmentSizeLimitErrorFlag"] = $57725dc45b51a081$export$1c61cf0ed486df46;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isShareableLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("dA1Sn", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $42omo.useState)(isNoSSR || !fullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $42omo.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { style: style, name: name, children: children, enabled: t1 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if ((0, $6mKj3.expValEquals)("cc_fix_hydration_ttvc", "isEnabled", true)) {
        if (!enabled) return children;
        if (hydrated) {
            let t2;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                };
                $[0] = t2;
            } else t2 = $[0];
            let t3;
            if ($[1] !== children || $[2] !== name) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    "data-testid": "two-stage-hydration",
                    "data-fullcycle-name": name,
                    style: t2
                }, children);
                $[1] = children;
                $[2] = name;
                $[3] = t3;
            } else t3 = $[3];
            return t3;
        }
        const innerHTML = fullCycleOutput;
        let t2;
        if ($[4] !== innerHTML) {
            t2 = {
                __html: innerHTML
            };
            $[4] = innerHTML;
            $[5] = t2;
        } else t2 = $[5];
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== name || $[8] !== t2) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                dangerouslySetInnerHTML: t2,
                style: t3
            });
            $[7] = name;
            $[8] = t2;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    if (!enabled || hydrated) return children;
    const innerHTML_0 = fullCycleOutput;
    let t2;
    if ($[14] !== innerHTML_0) {
        t2 = {
            __html: innerHTML_0
        };
        $[14] = innerHTML_0;
        $[15] = t2;
    } else t2 = $[15];
    let t3;
    if ($[16] !== name || $[17] !== style || $[18] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            dangerouslySetInnerHTML: t2
        });
        $[16] = name;
        $[17] = style;
        $[18] = t2;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
} : ({ style: style, name: name, children: children, enabled: enabled = false })=>{
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if ((0, $6mKj3.expValEquals)('cc_fix_hydration_ttvc', 'isEnabled', true)) {
        if (!enabled) return children;
        // NOTE: REACT_SSR is used intentionally here to allow for the two-stage hydration to work
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (hydrated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: {
                position: 'relative',
                height: '100%',
                width: '100%'
            }
        }, children);
        // TEMP: observed odd React behavior during two-stage hydration. Apparently it doesn't care about interim state
        // of the component upon hydration as long as it is *synchronously* rendered, so empty HTML makes no difference
        // and doesn't cause blank flash. So less work is better in this case. However if hydration fails and React
        // falls back to client rendering the blank flash occurs, so `innerHTML` comes handy here.
        const innerHTML = fullCycleOutput;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: innerHTML
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: {
                position: 'relative',
                height: '100%',
                width: '100%'
            }
        });
    }
    if (!enabled || hydrated) return children;
    // TEMP: observed odd React behavior during two-stage hydration. Apparently it doesn't care about interim state
    // of the component upon hydration as long as it is *synchronously* rendered, so empty HTML makes no difference
    // and doesn't cause blank flash. So less work is better in this case. However if hydration fails and React
    // falls back to client rendering the blank flash occurs, so `innerHTML` comes handy here.
    const innerHTML_0 = fullCycleOutput;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-testid": "two-stage-hydration",
        "data-fullcycle-name": name,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: innerHTML_0
        }
    });
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { name: name, style: style, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6mKj3.expValEquals)("confluence_editor_hydration_partial", "isEnabled", true);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== name || $[3] !== style) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            style: style,
            enabled: t1
        }, children);
        $[1] = children;
        $[2] = name;
        $[3] = style;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ name: name, style: style, children: children })=>{
    return(// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
        name: name,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        enabled: (0, $6mKj3.expValEquals)('confluence_editor_hydration_partial', 'isEnabled', true)
    }, children));
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("9EtP6", function(module, exports) {
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$baseStylesT26Shape = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81ixg _1tn22smr",
    monospace: "_11c81ixg _ect41odn _1tn22smr _14mdudxr"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $l998X.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $42omo.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("cQbj1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $95931c783b128167$var$_react = $95931c783b128167$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $95931c783b128167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95931c783b128167$var$Presentation24Icon = (props)=>/*#__PURE__*/ $95931c783b128167$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$95931c783b128167$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $95931c783b128167$var$_default = module.exports.default = $95931c783b128167$var$Presentation24Icon;

});

parcelRegister("iFCP2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d97a2b9af590931e$var$_react = $d97a2b9af590931e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d97a2b9af590931e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d97a2b9af590931e$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d97a2b9af590931e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d97a2b9af590931e$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d97a2b9af590931e$var$_default = module.exports.default = $d97a2b9af590931e$var$Spreadsheet24Icon;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("gj7hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cv8Bu = parcelRequire("cv8Bu");


var $cOrQJ = parcelRequire("cOrQJ");

const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $42omo.useRef)(null);
    const providedColorMode = (0, $cv8Bu.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $42omo.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});

parcelRegister("cv8Bu", function(module, exports) {
/* theme-provider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");


var $8z9j5 = parcelRequire("8z9j5");

var $hY0xh = parcelRequire("hY0xh");

var $bRSdj = parcelRequire("bRSdj");

var $60yhz = parcelRequire("60yhz");

const $d32a212d6e794c84$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: 'typography'
    });
const $d32a212d6e794c84$var$ColorModeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$SetColorModeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$ThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$SetThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined); /**
                                                                                                  * __UNSAFE_useColorModeForMigration()__
                                                                                                  *
                                                                                                  * Returns the current color mode when inside the app provider.
                                                                                                  * Unlike useColorMode, this utility returns undefined, instead of throwing an error, when the app provider is missing.
                                                                                                  * This allows it to be used by components that need to operate with and without an app provider.
                                                                                                  */ 
function $d32a212d6e794c84$export$ce91654eb9fea460() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$ColorModeContext);
    return value;
} /**
   * __useColorMode()__
   *
   * Returns the current color mode when inside the app provider.
   */ 
function $d32a212d6e794c84$export$20f3076712c8dfa() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$ColorModeContext);
    const { colorMode: colorMode } = (0, $8z9j5.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $42omo.useState)(colorMode || 'light');
    (0, $42omo.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $60yhz.default)((theme)=>{
            setResolvedColorMode(theme.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $d32a212d6e794c84$export$e2afe7397c3d11c7() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
} /**
   * __useTheme()__
   *
   * Returns the current theme settings when inside the app provider.
   */ 
function $d32a212d6e794c84$export$93d4e7f90805808f() {
    const theme = (0, $42omo.useContext)($d32a212d6e794c84$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $42omo.useState)(theme || (0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $60yhz.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
} /**
   * __useSetTheme()__
   *
   * Returns the theme setter when inside the app provider.
   */ 
function $d32a212d6e794c84$export$501aa0dcd5527a48() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $d32a212d6e794c84$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $d32a212d6e794c84$var$prefersDarkModeMql = $d32a212d6e794c84$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $d32a212d6e794c84$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $d32a212d6e794c84$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $d32a212d6e794c84$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $d32a212d6e794c84$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $42omo.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $42omo.useState)($d32a212d6e794c84$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $42omo.useState)(()=>({
            ...$d32a212d6e794c84$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $42omo.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($d32a212d6e794c84$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $42omo.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // If fg enabled avoid mounting themes
        if ((0, $dh538.fg)('platform-static-theme-loading')) return;
         /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ 
        const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $bRSdj.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!$d32a212d6e794c84$var$prefersDarkModeMql) return;
        const unbindListener = (0, $fFa3V.bind)($d32a212d6e794c84$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = (0, $hY0xh.default)({
        ...theme,
        colorMode: reconciledColorMode
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: (0, $dh538.fg)('platform-static-theme-loading') ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        "data-theme": attrs['data-theme'],
                        "data-color-mode": attrs['data-color-mode'],
                        className: (0, $gMc0m.default)([
                            $d32a212d6e794c84$var$contentStyles.body
                        ]),
                        children: children
                    }) : children
                })
            })
        })
    });
}
var $d32a212d6e794c84$export$2e2bcd8739ae039 = $d32a212d6e794c84$var$ThemeProvider;
module.exports["UNSAFE_useColorModeForMigration"] = $d32a212d6e794c84$export$ce91654eb9fea460;

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("9k33u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $l998X.jsx)($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("i2CQL", function(module, exports) {

var $equi6 = parcelRequire("equi6");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $equi6.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("equi6", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $a80afd8c2b9b4a58$export$6ccbb43953eebf8);

var $l7KxQ = parcelRequire("l7KxQ");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $a80afd8c2b9b4a58$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $a80afd8c2b9b4a58$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = false;
const $a80afd8c2b9b4a58$var$identity = (arg)=>arg;
function $a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector = $a80afd8c2b9b4a58$var$identity, equalityFn) {
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$a80afd8c2b9b4a58$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = true;
    }
    const slice = $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $a80afd8c2b9b4a58$var$useDebugValue(slice);
    return slice;
}
const $a80afd8c2b9b4a58$var$createImpl = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $l7KxQ.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $a80afd8c2b9b4a58$export$185802fd694ee1f5 = (createState)=>createState ? $a80afd8c2b9b4a58$var$createImpl(createState) : $a80afd8c2b9b4a58$var$createImpl;
var $a80afd8c2b9b4a58$export$2e2bcd8739ae039 = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $a80afd8c2b9b4a58$export$185802fd694ee1f5(createState);
};

});

parcelRegister("4GGNn", function(module, exports) {

var $GLgaM = parcelRequire("GLgaM");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError }) {
    const json = await (0, $GLgaM.fetchResponse)({
        url: url,
        method: method,
        body: body,
        headers: headers,
        credentials: credentials,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    }, variables);
    const data = await parseResult(json, variables);
    return {
        data: data
    };
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});


//# sourceMappingURL=EditorPageCoverPicture.a29c526a.js.map
